<template>
  <!-- scanEntry >>> 微信表单控件 by lbj-->
  <div class="addFrom">
    <!-- 基本信息 -->
    <!-- <el-form ref="form" :inline="true" :model="form" label-position="right"> -->
    <van-form ref="form"
              :inline="true"
              :model="form"
              label-position="right">
      <div v-for="(item, index) in form.loopData"
           :key="index"
           v-show="singleCroList[index].show"
           class="right_content">
        <div v-if="item[0].appgroupname"
             class="right_titlepar">
          <div class="right_title">
            <div class="msgTitle">
              <!-- <div class="lump" /> -->
              <div>{{ item[0].appgroupname }}</div>
            </div>
            <div class="titlebtn"
                 @click="item[0].uptools = !item[0].uptools">
              <svg-icon :icon-class="item[0].uptools ? 'twodowngri' : 'twoupgr'" />
            </div>
          </div>
        </div>

        <div class="sheet"
             v-show="item[0].uptools">
          <div v-for="(list, idx) in item"
               :key="idx"
               class="elwrapper"
               v-show="list.formshow">
            <!-- 密码框/只读/文本框/下拉框   -->
            <!-- :rows="list.controltype === 'memo'?list.controlheight:2"
            :autosize="(list.controltype === 'memo' && pageshow)?true:{ maxHeight: 120, minHeight: 50 }" 因为样式问题，改为自定义文本域-->
            <van-field :class="
                list.app_caption_sep_row ? 'field-app_caption_sep_row' : ''
              "
                       v-if="
                list.formshow &&
                  inputControltype2.indexOf(list.controltype) > -1
              "
                       v-model="list.formdata"
                       :name="list.chnname"
                       :ref="list.fieldname"
                       :required="list.mustinput"
                       :rules="[{ required: list.mustinput, message: '必填' }]"
                       :type="
                !list.isread
                  ? 'password'
                  : list.controltype === 'memo'
                  ? 'textarea'
                  : ''
              "
                       :disabled="
                !list.iswrite ||
                  list.isreadonly ||
                  !list.isread ||
                  status === 'readonly'
              "
                       :readonly="
                !list.iswrite ||
                  list.isreadonly ||
                  !list.isread ||
                  status === 'readonly' ||
                  (list.controltype === 'combobox' &&
                    list.comdropstyle != 'lsEditList')
              "
                       :clickable="
                list.controltype === 'combobox' &&
                  list.comdropstyle != 'lsEditList'
              "
                       :placeholder="
                (inputControltype.indexOf(list.controltype) > -1
                  ? '请输入'
                  : '请选择') + list.chnname.replace('<br>', '')
              "
                       @change="
                val => {
                  b4valuechage(val, list)
                }
              "
                       @click="
                ;(!(
                  !list.iswrite ||
                  list.isreadonly ||
                  !list.isread ||
                  status === 'readonly'
                ) &&
                  (list.controltype === 'combobox' ||
                    list.controltype === 'lookupcombobox') &&
                  list.comdropstyle != 'lsEditList' &&
                  !list.ispoptree &&
                  comboboxNoispoptreefocus(
                    list.listsql,
                    list.controltype,
                    list
                  )) ||
                  (!(
                    !list.iswrite ||
                    list.isreadonly ||
                    !list.isread ||
                    status === 'readonly'
                  ) &&
                    (list.controltype === 'datetime' ||
                      list.controltype === 'longdatetime') &&
                    showdatepick(list)) ||
                  (!(
                    !list.iswrite ||
                    list.isreadonly ||
                    !list.isread ||
                    status === 'readonly'
                  ) &&
                    list.controltype === 'combobox' &&
                    list.comdropstyle != 'lsEditList' &&
                    list.ispoptree &&
                    showTree(list))
              "
                       @blur="blurSomeField(list.fieldname, list.formdata)">
              <!-- 自定义左侧的label -->
              <template #label>
                <div v-html="list.chnname"></div>
              </template>
              <!-- 普通下拉/表格下拉 -->
              <template v-if="
                  !(
                    !list.iswrite ||
                    list.isreadonly ||
                    !list.isread ||
                    status === 'readonly'
                  ) &&
                    (list.controltype === 'combobox' ||
                      list.controltype === 'lookupcombobox' ||
                      list.controltype == 'maskedit') &&
                    !list.ispoptree
                "
                        #right-icon>
                <!-- <van-icon v-if="list.controltype =='maskedit' && list.maskeditstr =='CitySelector'"
                          name="location-o"
                          @click="citySelectorFocus(list)" /> -->
                <!-- 右边下拉图标 -->
                <van-icon name="arrow-down"
                          @click="
                    comboboxNoispoptreefocus(
                      list.listsql,
                      list.controltype,
                      list
                    )
                  " />
              </template>
              <template v-else-if="
                  !(
                    !list.iswrite ||
                    list.isreadonly ||
                    !list.isread ||
                    status === 'readonly'
                  ) &&
                    list.controltype === 'combobox' &&
                    list.ispoptree
                "
                        #right-icon>
                <!-- 右边下拉图标 -->
                <van-icon name="arrow-down"
                          @click="showTree(list)" />
              </template>
              <!-- 身份证号码 图标 -->
              <template v-else-if="list.fieldname == 'idcardnum' && use_identify_ocr"
                        #right-icon>
                <van-icon name="photo-o"
                          @click="showIdCardDia(list)" />
              </template>
              <!-- 银行卡识别图标 -->
              <template v-else-if="list.fieldname == bank_orc_bankaccount_field && use_bank_ocr"
                        #right-icon>
                <van-icon name="ecard-pay"
                          @click="showBankCardDia(list)" />
              </template>
              <!-- 自定义文本域 -->
              <template v-if="list.controltype === 'memo'"
                        #input>
                <textarea v-model="list.formdata"
                          :rows="list.controltype === 'memo' ? list.controlheight : 2"
                          :name="list.chnname"
                          :placeholder="
                    (inputControltype.indexOf(list.controltype) > -1
                      ? '请输入'
                      : '请选择') + list.chnname.replace('<br>', '')
                  "
                          class="van-field__control"
                          :style="[
                    {
                      height: list.controlheight
                        ? list.controlheight * 50 + 'px'
                        : '120px'
                    }
                  ]"
                          :disabled="
                    !list.iswrite ||
                      list.isreadonly ||
                      !list.isread ||
                      status === 'readonly'
                  "
                          :readonly="
                    !list.iswrite ||
                      list.isreadonly ||
                      !list.isread ||
                      status === 'readonly' ||
                      (list.controltype === 'combobox' &&
                        list.comdropstyle != 'lsEditList')
                  "></textarea>
              </template>
            </van-field>
            <!-- checkbox -->
            <van-field v-else-if="list.formshow && list.controltype === 'checkbox'"
                       :class="
                list.app_caption_sep_row ? 'field-app_caption_sep_row' : ''
              "
                       :name="list.chnname"
                       :ref="list.fieldname"
                       :required="list.mustinput"
                       :rules="[{ required: list.mustinput, message: '必填' }]"
                       :disabled="
                !list.iswrite ||
                  list.isreadonly ||
                  !list.isread ||
                  status === 'readonly'
              "
                       :readonly="
                !list.iswrite ||
                  list.isreadonly ||
                  !list.isread ||
                  status === 'readonly'
              "
                       @change="
                val => {
                  b4valuechage(val, list)
                }
              ">
              <!-- 自定义左侧的label -->
              <template #label>
                <div v-html="list.chnname"></div>
              </template>
              <template #input>
                <!-- 开关 -->
                <van-switch v-model="list.formdata"
                            size="20" />
              </template>
            </van-field>
            <!-- maskedit -->
            <van-field v-else-if="list.formshow && list.controltype == 'maskedit'"
                       :class="
                list.app_caption_sep_row ? 'field-app_caption_sep_row' : ''
              "
                       :name="list.chnname"
                       :ref="list.fieldname"
                       v-model="list.formdata"
                       :required="list.mustinput"
                       :rules="[{ required: list.mustinput, message: '必填' }]"
                       :disabled="
                !list.iswrite ||
                  list.isreadonly ||
                  !list.isread ||
                  status === 'readonly'
              "
                       :readonly="
                !list.iswrite ||
                  list.isreadonly ||
                  !list.isread ||
                  status === 'readonly'
              "
                       @input="keyup(list)"
                       @change="
                val => {
                  b4valuechage(val, list)
                }
              "
                       @blur="blurSomeField(list.fieldname, list.formdata)">
              <!-- 自定义左侧的label -->
              <template #label>
                <div v-html="list.chnname"></div>
              </template>
              <template v-if="list.maskeditstr == 'CitySelector'"
                        #right-icon>
                <van-icon name="location-o"
                          @click="citySelectorFocus(list)" />
              </template>
              <!-- 身份证号码 图标 -->
              <template v-else-if="list.fieldname == 'idcardnum' && use_identify_ocr"
                        #right-icon>
                <van-icon name="photo-o"
                          @click="showIdCardDia(list)" />
              </template>
              <!-- 银行卡识别图标 -->
              <template v-else-if="list.fieldname == bank_orc_bankaccount_field && use_bank_ocr"
                        #right-icon>
                <van-icon name="ecard-pay"
                          @click="showBankCardDia(list)" />
              </template>
            </van-field>
            <!-- <el-form-item
              v-if="list.formshow && !list.isread"
              :label="list.chnname+':'"
              :title="list.chnname"
              :required="list.mustinput"
              :prop="`loopData.${index}.${idx}.formdata`"
              :rules="[{ required: list.mustinput, message: ' ' }]"
              :class="{
                readonly:
                  !list.iswrite || list.isreadonly || status === 'readonly',
                mustinput: list.mustinput,
              }">
              <label v-if="status === 'readonly'">: {{ list.formdata }}</label>
              <el-input v-else
                        v-model="list.formdata"
                        :readonly="true"
                        @change="
                  (val) => {
                    valuechage(val, list);
                  }
                "
                :ref="list.fieldname"
                show-password
              />
            </el-form-item>-->
            <!-- 只读 -->
            <!-- <el-form-item
              v-else-if="status === 'readonly'"
              :label="list.chnname+':'"
              :title="list.chnname"
              :required="list.mustinput"
              :prop="`loopData.${index}.${idx}.formdata`"
              :rules="[{ required: list.mustinput, message: ' ' }]"
              :class="{
                readonly:
                  !list.iswrite || list.isreadonly || status === 'readonly',
                mustinput: list.mustinput,
              }">
              <label class="readonly-label">: {{ list.formdata }}</label>
            </el-form-item>-->
            <!-- 文本框 -->
            <!-- <el-form-item
              v-else-if="list.formshow && list.controltype === 'edit'"
              :label="list.chnname+':'"
              :title="list.chnname"
              :required="list.mustinput"
              :prop="`loopData.${index}.${idx}.formdata`"
              :rules="[{ required: list.mustinput, message: ' ' }]"
              :class="{
                readonly:
                  !list.iswrite || list.isreadonly || status === 'readonly',
                mustinput: list.mustinput,
              }">
              <el-input v-model="list.formdata"
                        :readonly="
                  !list.iswrite || list.isreadonly || status === 'readonly'
                "
                        @change="
                  (val) => {
                    valuechage(val, list);
                  }
                "
                :ref="list.fieldname"
              />
            </el-form-item>-->
            <!-- 文本域 -->
            <!-- <el-form-item
              v-else-if="list.formshow && list.controltype === 'memo'"
              :label="''"
              :title="list.chnname"
              :required="list.mustinput"
              :prop="`loopData.${index}.${idx}.formdata`"
              :rules="[{ required: list.mustinput, message: ' ' }]"
              :class="{
                readonly:
                  !list.iswrite || list.isreadonly || status === 'readonly',
                mustinput: list.mustinput,
                memo: true,
              }">
              <el-input type="textarea"
                        v-model="list.formdata"
                        :readonly="
                  !list.iswrite || list.isreadonly || status === 'readonly'
                "
                        @change="
                  (val) => {
                    valuechage(val, list);
                  }
                "
                :rows="list.controlheight*2"
                :ref="list.fieldname"
              />
            </el-form-item>-->
            <!-- 自定义弹出窗体 -->
            <!-- <el-form-item
              v-else-if="
                list.formshow &&
                  list.controltype === 'combobox' &&
                  list.showpopquery
              "
                          :label="list.chnname+':'"
                          :title="list.chnname"
                          :required="list.mustinput"
                          :prop="`loopData.${index}.${idx}.formdata`"
                          :rules="[{ required: list.mustinput, message: ' ' }]"
                          @change="
                (val) => {
                  valuechage(val, list);
                }
              "
                          :class="{
                readonly:
                  !list.iswrite || list.isreadonly || status === 'readonly',
                mustinput: list.mustinput,
              }">
              <el-col>
                <el-input v-model="list.formdata"
                          :readonly="
                    !list.iswrite ||
                      list.isreadonly ||
                      list.comdropstyle != 'lsEditList' ||
                      status === 'readonly'
                  "
                          @change="
                    (val) => {
                      valuechage(val, list);
                    }
                  "
                          :ref="list.fieldname"
                          @input="showCuQuery(list)" />

                <span class="el-input__prefix"
                      style="right:5px;left:initial;color: #606266;font-size:16px"
                      :class="
                    !list.iswrite || list.isreadonly || status === 'readonly'
                      ? 'div-readonly'
                      : ''
                  "
                      @click="showCuQuery(list)">
                  <i class="el-select__caret el-input__icon el-icon-arrow-up"
                     style="transform: rotateZ(180deg);cursor: pointer;line-height: 32px;"></i>
                </span>
                <span v-if="
                    moduleConfig.canselmulti &&
                      moduleConfig.multifieldname === list.fieldname &&
                      status === 'save'
                  "
                      class="el-input__prefix"
                      style="right:-20px;left:initial;color:rgba(0, 141, 247, 1);"
                      title="批量新增">
                  <svg-icon icon-class="m201btn03"
                            style="font-size:16px"
                            :class="
                      !list.iswrite || list.isreadonly || status === 'readonly'
                        ? 'div-readonly'
                        : ''
                    "
                            @click="b4multi(list)" />
                </span>
              </el-col>
            </el-form-item>-->
            <!-- 普通下拉框 -->
            <!-- <el-form-item
              v-else-if="
                list.formshow &&
                  list.controltype === 'combobox' &&
                  !list.ispoptree
              "
                          :label="list.chnname+':'"
                          :title="list.chnname"
                          :required="list.mustinput"
                          :prop="`loopData.${index}.${idx}.formdata`"
                          :rules="[{ required: list.mustinput, message: ' ' }]"
                          :class="{
                readonly:
                  !list.iswrite || list.isreadonly || status === 'readonly',
                mustinput: list.mustinput,
              }">
              <el-input v-model="list.formdata"
                        :readonly="
                  !list.iswrite ||
                    list.isreadonly ||
                    list.comdropstyle != 'lsEditList' ||
                    status === 'readonly'
                "
                        @change="
                  (val) => {
                    valuechage(val, list);
                  }
                "
                        :ref="list.fieldname"
                        @click.native="
                  comboboxNoispoptreefocus(list.listsql, list.controltype, list)
                " />

              <span v-show="
                  !(!list.iswrite || list.isreadonly || status === 'readonly')
                "
                    class="el-input__prefix"
                    style="right:5px;left:initial;color: #606266;font-size:16px"
                    :class="
                  !list.iswrite || list.isreadonly || status === 'readonly'
                    ? 'div-readonly'
                    : ''
                "
                    @click="
                  comboboxNoispoptreefocus(list.listsql, list.controltype, list)
                "
              >
                <i
                  class="el-select__caret el-input__icon el-icon-arrow-up"
                  style="transform: rotateZ(180deg);cursor: pointer;line-height: 32px;"
                ></i>
            </span>-->

            <!-- <el-select
                v-model="list.formdata"
                clearable
                placeholder="请选择"
                @focus="
                        comboboxNoispoptreefocus(list.listsql, list.controltype)
                      "
                :filterable="list.comdropstyle === 'lsEditList'"
                :allow-create="list.comdropstyle === 'lsEditList'"
                :default-first-option="list.comdropstyle === 'lsEditList'"
                @change="
                        val => {
                          valuechage(val, list);
                        }
                      "
                :ref="list.fieldname"
                :readonly="
                        !list.iswrite ||
                          list.isreadonly ||
                          status === 'readonly'
                      "
                :disabled="
                        !list.iswrite ||
                          list.isreadonly ||
                          status === 'readonly'
                      "
                @blur="event => addoption(list, event)"
              >
                <el-option
                  v-for="(choice, i) in choices"
                  :key="i"
                  :label="choice.dicvalue"
                  :value="choice.dicvalue"
                />
            </el-select>-->
            <!-- <span
                v-if="
                  moduleConfig.canselmulti &&
                    moduleConfig.multifieldname === list.fieldname &&
                    status === 'save'
                "
                    class="el-input__prefix"
                    style="right:-20px;left:initial;color:rgba(0, 141, 247, 1);"
                    title="批量新增">
                <svg-icon icon-class="m201btn03"
                          style="font-size:16px"
                          :class="
                    !list.iswrite || list.isreadonly || status === 'readonly'
                      ? 'div-readonly'
                      : ''
                  "
                          @click="b4multi(list)" />
              </span>
            </el-form-item>-->
            <!-- 表格下拉框 -->
            <!-- <el-form-item
              v-else-if="
                list.formshow &&
                  list.controltype === 'lookupcombobox' &&
                  !list.ispoptree
              "
                          :label="list.chnname+':'"
                          :title="list.chnname"
                          :required="list.mustinput"
                          :prop="`loopData.${index}.${idx}.formdata`"
                          :rules="[{ required: list.mustinput, message: ' ' }]"
                          :class="{
                readonly:
                  !list.iswrite || list.isreadonly || status === 'readonly',
                mustinput: list.mustinput,
              }">
              <el-select v-model="list.formdata"
                         clearable
                         placeholder="请选择"
                         @focus="
                  comboboxNoispoptreefocus(list.listsql, list.controltype, list)
                "
                         :filterable="list.comdropstyle === 'lsEditList'"
                         :allow-create="list.comdropstyle === 'lsEditList'"
                         :default-first-option="list.comdropstyle === 'lsEditList'"
                         @change="
                  (val) => {
                    valuechage(val, list);
                  }
                "
                         :ref="list.fieldname"
                         :readonly="
                  !list.iswrite || list.isreadonly || status === 'readonly'
                "
                         :disabled="
                  !list.iswrite || list.isreadonly || status === 'readonly'
                "
                         @blur="(event) => addoption(list, event)">
                <el-option v-for="(choice, i) in choices.head"
                           :key="i - 1"
                           :label="0"
                           :value="0"
                           :disabled="true">
                  <table width="100%">
                    <tr>
                      <td v-for="(key, j) in choice.name"
                          :key="j"
                          :style="{ width: choice.width[j] + 'em' }">{{ key }}</td>
                    </tr>
                  </table>
                </el-option>

                <el-option v-for="(choice, i) in choices.data"
                           :key="i"
                           :label="choice[0]"
                           :value="choice[0]">
                  <table width="100%">
                    <tr>
                      <td v-for="(k, idx) in choice"
                          :key="idx"
                          :style="{
                          width: choices.head[0].width[idx] + 'em',
                        }"
                      >{{ k }}</td>                     
                    </tr>
                  </table>
                </el-option>
              </el-select>
            </el-form-item>-->

            <!-- 下拉框弹出树(不区分员工树) -->
            <!-- <el-form-item
              v-else-if="
                list.formshow &&
                  list.controltype === 'combobox' &&
                  list.ispoptree 
              "
                          :label="list.chnname+':'"
                          :title="list.chnname"
                          :required="list.mustinput"
                          :prop="`loopData.${index}.${idx}.formdata`"
                          :rules="[{ required: list.mustinput, message: ' ' }]"
                          @change="
                (val) => {
                  valuechage(val, list);
                }
              "
                          :class="{
                readonly:
                  !list.iswrite || list.isreadonly || status === 'readonly',
                mustinput: list.mustinput,
              }">
              <el-col>
                <el-input v-model="list.formdata"
                          :readonly="
                    !list.iswrite ||
                      list.isreadonly ||
                      list.comdropstyle != 'lsEditList' ||
                      status === 'readonly'
                  "
                          @change="
                    (val) => {
                      valuechage(val, list);
                    }
                  "
                          :ref="list.fieldname"
                          @input="showTree(list)" />

                <span class="el-input__prefix"
                      style="right:5px;left:initial;color: #606266;font-size:16px"
                      :class="
                    !list.iswrite || list.isreadonly || status === 'readonly'
                      ? 'div-readonly'
                      : ''
                  "
                      @click="showTree(list)">
                  <i class="el-select__caret el-input__icon el-icon-arrow-up"
                     style="transform: rotateZ(180deg);cursor: pointer;line-height: 32px;"></i>
                </span>
                <span v-if="
                    moduleConfig.canselmulti &&
                      moduleConfig.multifieldname === list.fieldname &&
                      status === 'save'
                  "
                      class="el-input__prefix"
                      style="right:-20px;left:initial;color:rgba(0, 141, 247, 1);"
                      title="批量新增">
                  <svg-icon icon-class="m201btn03"
                            style="font-size:16px"
                            :class="
                      !list.iswrite || list.isreadonly || status === 'readonly'
                        ? 'div-readonly'
                        : ''
                    "
                            @click="b4multi(list)" />
                </span>
              </el-col>
            </el-form-item>-->
            <!-- 下拉框弹出树(员工树) -->
            <!-- <el-form-item v-else-if="
                list.formshow &&
                  list.controltype === 'combobox' &&
                  list.ispoptree &&
                  list.poptreename === 'emptree'
              "
                          :label="list.chnname+':'"
                          :title="list.chnname"
                          :required="list.mustinput"
                          :prop="`loopData.${index}.${idx}.formdata`"
                          :rules="[{ required: list.mustinput, message: ' ' }]"
                          :class="{
                readonly:
                  !list.iswrite || list.isreadonly || status === 'readonly',
                mustinput: list.mustinput,
              }">
              <el-col>
                <el-input v-model="list.formdata"
                          :readonly="
                    !list.iswrite ||
                      list.isreadonly ||
                      list.comdropstyle != 'lsEditList' ||
                      status === 'readonly'
                  "
                          @change="
                    (val) => {
                      //valuechage(val, list);
                      //工号字段输入姓名转化方法
                      changeEmpname(val, list);
                    }
                  "
                          :ref="list.fieldname" />
                <span class="el-input__prefix"
                      style="right:5px;left:initial;color: #606266;font-size:16px">
                  <svg-icon icon-class="imgno"
                            style="font-size:16px"
                            :class="
                      !list.iswrite || list.isreadonly || status === 'readonly'
                        ? 'div-readonly'
                        : ''
                    "
                            @click="showSelectJobNum(list)" />
                </span>
                <span v-if="
                    moduleConfig.canselmulti &&
                      moduleConfig.multifieldname === list.fieldname &&
                      status === 'save'
                  "
                      class="el-input__prefix"
                      style="right:-20px;left:initial;color:rgba(0, 141, 247, 1);"
                      title="批量新增">
                  <svg-icon icon-class="m201btn03"
                            style="font-size:16px"
                            :class="
                      !list.iswrite || list.isreadonly || status === 'readonly'
                        ? 'div-readonly'
                        : ''
                    "
                            @click="b4multi(list)" />
                </span>
              </el-col>
            </el-form-item>-->
            <!-- 复选框 -->
            <!-- <el-form-item
              v-else-if="list.formshow && list.controltype === 'checkbox'"
              :label="list.chnname+':'"
              :title="list.chnname"
              :required="list.mustinput"
              :prop="`loopData.${index}.${idx}.formdata`"
              :rules="[{ required: list.mustinput, message: ' ' }]"
              :class="{
                readonly:
                  !list.iswrite || list.isreadonly || status === 'readonly',
                mustinput: list.mustinput,
              }"
              class="switch_item"
            >
              <el-switch
                v-model="list.formdata"
                class="switch_box"
                @change="
                  (val) => {
                    valuechage(val, list);
                  }
                "
                         :disabled="
                  !list.iswrite || list.isreadonly || status === 'readonly'
                "
                         :readonly="
                  !list.iswrite || list.isreadonly || status === 'readonly'
                "
                :ref="list.fieldname"
              />
            </el-form-item>-->
            <!-- 日期框 -->
            <!-- <el-form-item
              v-else-if="list.formshow && list.controltype === 'datetime'"
              :label="list.chnname+':'"
              :title="list.chnname"
              :required="list.mustinput"
              :prop="`loopData.${index}.${idx}.formdata`"
              :rules="[{ required: list.mustinput, message: ' ' }]"
              :class="{
                readonly:
                  !list.iswrite || list.isreadonly || status === 'readonly',
                mustinput: list.mustinput,
              }"
            >-->
            <!-- <el-col>
                <el-date-picker
                  v-model="list.formdata"
                  type="date"
                  placeholder="选择日期"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  @change="
                          val => {
                            valuechage(val, list);
                          }
                        "
                  :ref="list.fieldname"
                  :readonly="
                          !list.iswrite ||
                            list.isreadonly ||
                            status === 'readonly'
                        "
                  v-on:input.native="handleDateInput"
                />
            </el-col>-->
            <!-- <el-input
                v-model="list.formdata"
                :readonly="true"
                @change="
                  (val) => {
                    valuechage(val, list);
                  }
                "
                        :ref="list.fieldname"
                        @click.native="showdatepick(list)" />

              <span class="el-input__prefix"
                    style="right:5px;left:initial;color: #606266;font-size:16px"
                    :class="
                  !list.iswrite || list.isreadonly || status === 'readonly'
                    ? 'div-readonly'
                    : ''
                "
                    @click="showdatepick(list)">
                <i class="el-select__caret el-input__icon el-icon-arrow-up"
                   style="transform: rotateZ(180deg);cursor: pointer;line-height: 32px;"></i>
              </span>
            </el-form-item>-->
            <!-- 日期时间框 -->
            <!-- <el-form-item
              v-else-if="list.formshow && list.controltype === 'longdatetime'"
              :label="list.chnname+':'"
              :title="list.chnname"
              :required="list.mustinput"
              :prop="`loopData.${index}.${idx}.formdata`"
              :rules="[{ required: list.mustinput, message: ' ' }]"
              :class="{
                readonly:
                  !list.iswrite || list.isreadonly || status === 'readonly',
                mustinput: list.mustinput,
              }">
              <el-col>
                <el-date-picker v-model="list.formdata"
                                type="datetime"
                                placeholder="选择日期时间"
                                value-format="yyyy-MM-dd HH:mm:ss"
                                @change="
                    (val) => {
                      valuechage(val, list);
                    }
                  "
                                :ref="list.fieldname"
                                :editable="true"
                                :readonly="
                    !list.iswrite || list.isreadonly || status === 'readonly'
                  "
                                v-on:input.native="handleDateTimeInput" />
              </el-col>
            </el-form-item>-->
            <!-- 时间框 -->
            <!-- <el-form-item
              v-else-if="list.formshow && list.controltype === 'maskedit'"
              :label="list.chnname+':'"
              :title="list.chnname"
              :required="list.mustinput"
              :prop="`loopData.${index}.${idx}.formdata`"
              :rules="[{ required: list.mustinput, message: ' ' }]"
              :class="{
                readonly:
                  !list.iswrite || list.isreadonly || status === 'readonly',
                mustinput: list.mustinput,
              }">
              <el-input v-model="list.formdata"
                        :readonly="
                  !list.iswrite || list.isreadonly || status === 'readonly'
                "
                        @change="
                  (val) => {
                    valuechage(val, list);
                  }
                "
                :ref="list.fieldname"
                v-on:input.native="handleTimeInput"
                v-on:keydown.native="keydown"
              />
            </el-form-item>-->
            <!-- 多行文本框 -->
            <!-- <el-form-item
              v-else-if="list.formshow && list.controltype === 'memo'"
              :label="list.chnname+':'"
              :title="list.chnname"
              :required="list.mustinput"
              :prop="`loopData.${index}.${idx}.formdata`"
              :rules="[{ required: list.mustinput, message: ' ' }]"
              :class="{
                      readonly:
                        !list.iswrite ||
                        list.isreadonly ||
                        status === 'readonly',
                      mustinput: list.mustinput
                    }"
            >
              <el-input
                v-model="list.formdata"
                type="textarea"
                class="wode"
                :rows="list.controlheight"
                @change="
                        val => {
                          valuechage(val, list);
                        }
                      "
                :ref="list.fieldname"
                :readonly="
                        !list.iswrite ||
                          list.isreadonly ||
                          status === 'readonly'
                      "
                :style="{
                        height: list.controlheight * 47 + 'px'
                      }"
              />
            </el-form-item>-->
            <!-- 颜色选项卡 -->
            <!-- <el-form-item
              v-else-if="list.formshow && list.controltype === 'colorcombobox'"
              :label="list.chnname+':'"
              :title="list.chnname"
              :required="list.mustinput"
              :prop="`loopData.${index}.${idx}.formdata`"
              :rules="[{ required: list.mustinput, message: ' ' }]"
              :class="{
                readonly:
                  !list.iswrite || list.isreadonly || status === 'readonly',
                mustinput: list.mustinput,
              }">
              <el-color-picker v-model="list.formdata"
                               :ref="list.fieldname"
                               :disabled="
                  !list.iswrite || list.isreadonly || status === 'readonly'
                "
                               @change="
                  (val) => {
                    valuechage(val, list);
                  }
                "
              ></el-color-picker>
            </el-form-item>-->
          </div>
        </div>
        <!-- 每个分组的附件 -->
        <div class="empPic"
             v-if="item.fileList">
          <!-- <div class="right_titlepar">
            <div class="right_title">
              <div class="msgTitle">
                <div>附件信息</div>
              </div>
            </div>
          </div>-->
          <van-field label="附件信息"
                     readonly />

          <div class="picbox">
            <div class="pp"
                 v-for="(fl, ix) in item.fileList"
                 :key="ix">
              <van-image width="20vw"
                         height="20vw"
                         alt="1"
                         :src="fl.url"
                         @click="openUpload(fl)" />
              <div v-if="fl.url && (!fl.autoid || !notDeleteAtfile)"
                   @click="del(fl)"
                   class="van-uploader__preview-delete">
                <van-icon name="cross" />
              </div>
              <div>{{ fl.name }}</div>
            </div>
            <!-- <van-uploader v-show="false"
                          :ref="`'groupuploader'+${index}`"
                          v-model="fileList2"
                          :lazy-load="true"
                          :max-count="1"
                          accept="image/*, .pdf, .doc, .docx, .jpg, .png, .xls, .xlsx"
                          :max-size="10 * 1024 * 1024"
                          :before-read="beforeRead"
            @oversize="onOversize"></van-uploader>-->
          </div>
        </div>
      </div>
    </van-form>
    <template v-if="$slots['empPic'] && moduleno != '201'">
      <slot name="empPic" />
    </template>
    <div class="iptline"
         v-show="showAtfile"
         v-if="!showAppendix && isSon && sonAtList.length == 0">
      <label>
        附件
        <p>最多15张</p>
      </label>
      <van-uploader v-model="fileList"
                    multiple
                    :lazy-load="true"
                    :max-count="15"
                    accept="image/*, .pdf, .doc, .docx, .jpg, .png, .xls, .xlsx"
                    :max-size="10 * 1024 * 1024"
                    :preview-size="'20vw'"
                    :after-read="afterReadAttr"
                    :before-delete="beforeDel"
                    @delete="deletefile"
                    @oversize="onOversize"></van-uploader>
    </div>
    <div v-show="(showAppendix || (isSon && sonAtList.length > 0)) && showAtfile">
      <div class="iptline"
           v-if="!usedicfilename && !isSon">
        <label>
          附件
          <p>最多15张</p>
        </label>
        <van-uploader v-model="fileList"
                      multiple
                      :lazy-load="true"
                      :max-count="15"
                      accept="image/*, .pdf, .doc, .docx, .jpg, .png, .xls, .xlsx"
                      :max-size="10 * 1024 * 1024"
                      :preview-size="'20vw'"
                      :after-read="afterReadAttr"
                      :before-delete="beforeDel"
                      @delete="deletefile"
                      @oversize="onOversize"></van-uploader>
      </div>
      <div class="empPic"
           v-if="
          (isSon && sonAtList.length > 0) ||
            (usedicfilename && !useMasterAtFile) ||
            (usedicfilename && useMasterAtFile && otherAtFileList)
        ">
        <div class="right_titlepar">
          <div class="right_title">
            <div class="msgTitle">
              <div>附件信息</div>
            </div>
            <div class="titlebtn"
                 @click="showEmppic = !showEmppic">
              <svg-icon :icon-class="showEmppic ? 'twodowngri' : 'twoupgr'" />
            </div>
          </div>
        </div>

        <div class="picbox"
             v-show="showEmppic">
          <div class="pp"
               v-for="(item, index) in fileList"
               :key="index">
            <van-image width="20vw"
                       height="20vw"
                       alt="1"
                       :src="item.url"
                       @click="openUpload(item)" />
            <div v-if="item.url && !item.readonly && (!item.autoid || !notDeleteAtfile)"
                 @click="del(item)"
                 class="van-uploader__preview-delete">
              <van-icon name="cross" />
            </div>
            <div>{{ item.name }}</div>
          </div>
        </div>
      </div>
      <van-uploader v-show="false"
                    ref="uploader"
                    v-model="fileList2"
                    :lazy-load="true"
                    :max-count="1"
                    accept="image/*, .pdf, .doc, .docx, .jpg, .png, .xls, .xlsx"
                    :max-size="10 * 1024 * 1024"
                    :before-read="beforeRead"
                    :after-read="afterReadAttr"
                    @oversize="onOversize"></van-uploader>
    </div>

    <!-- 省市区选择器弹窗 -->
    <van-popup v-model="showCitySelector"
               round
               position="bottom">
      <van-area title="选择省市区"
                :area-list="areaList"
                :columns-placeholder="['请选择', '请选择', '请选择']"
                @confirm="confirmCity"
                @cancel="showCitySelector = false" />
    </van-popup>

    <van-popup v-model="showPicker"
               :close-on-click-overlay="false"
               :close-on-popstate="false"
               round
               position="bottom">
      <van-picker :title="Selectformdata.chnname"
                  show-toolbar
                  :columns="choices"
                  @confirm="onConfirm"
                  @cancel="onCancel" />
    </van-popup>
    <van-popup v-model="showDtPicker"
               round
               position="bottom">
      <van-datetime-picker v-model="currentDate"
                           :type="
          Selectformdata.controltype === 'datetime'
            ? 'date'
            : Selectformdata.controltype === 'longdatetime'
            ? 'datetime'
            : Selectformdata.controltype === 'maskedit'
            ? 'time'
            : 'date'
        "
                           :min-date="minDate"
                           :max-date="maxDate"
                           :title="Selectformdata.chnname"
                           @confirm="onDtConfirm"
                           @cancel="showDtPicker = false" />
    </van-popup>
    <!-- 树弹窗 -->
    <van-popup class="tree_popup"
               v-model="showTreePop"
               closeable
               close-icon="arrow-left"
               close-icon-position="top-left"
               position="right"
               :style="{ width: '100%', height: '100%' }">
      <van-sticky class="fixed_div">
        <div class="tree_title">
          <span>{{ `请选择${Selectformdata.chnname}` }}</span>
        </div>
        <div class="tree_search">
          <van-search v-model="searchTreeVal"
                      placeholder="请输入搜索关键词"
                      @search="onSearchTree" />
        </div>
        <div class="tree_head">
          <span class="head_start"
                @click="backTo(true)">开始</span>
          <span v-for="(ele, idex) in clickParentTree"
                :key="idex"
                :class="idex == clickParentTree.length - 1 ? 'theLast' : 'noLast'"
                @click="backTo(ele)">
            <span class="division">></span>
            {{ ele.keyname }}
          </span>
        </div>
        <van-divider :style="{
            color: '#E8E8E8',
            borderColor: '#E8E8E8',
            margin: '5px 0 0 0'
          }" />
      </van-sticky>
      <div class="tree_body">
        <!-- 岗位树和员工树 -->
        <div v-if="whichTree == 'station' || whichTree == 'employee'">
          <!-- 多选树 -->
          <div v-if="multiseltree">
            <!-- 父节点 -->
            <van-cell class="parents_cell"
                      v-for="(item, index) in parentTreeList"
                      :key="index + item.keyname"
                      :title="item.keyname">
              <template #default>
                <div :class="item.hasLower ? 'haveClo' : 'noClo'"
                     @click="checkParent(item)">
                  <van-icon name="arrow-down" />
                  <span>下级</span>
                </div>
              </template>
              <template #icon>
                <van-checkbox v-model="item.checked"
                              @click="tickParent(item)"
                              shape="square"></van-checkbox>
              </template>
            </van-cell>
            <!-- 子节点 -->
            <van-cell class="childs_cell"
                      v-for="(it, idx) in childsTreeList"
                      :key="idx">
              <template #title>
                <van-checkbox v-model="it.checked"
                              shape="square">
                  <van-button size="small"
                              :icon="whichTree == 'employee' ? 'user-o' : 'manager-o'"
                              :type="whichTree == 'employee' ? 'warning' : 'primary'"></van-button>
                  <span class="check_name">{{ it.keyname }}</span>
                </van-checkbox>
              </template>
            </van-cell>
          </div>
          <!-- 非多选 -->
          <div v-else>
            <!-- 父节点 -->
            <van-cell class="parents_cell"
                      v-for="(item, index) in parentTreeList"
                      :key="index + item.keyname"
                      :title="item.keyname"
                      @click="checkParent(item)">
              <template #default>
                <div :class="item.hasLower ? 'haveClo' : 'noClo'">
                  <van-icon name="arrow-down" />
                  <span>下级</span>
                </div>
              </template>
            </van-cell>
            <!-- 子节点 -->
            <van-cell class="childs_cell"
                      v-for="(it, idx) in childsTreeList"
                      :key="idx"
                      @click="checkChild(it)">
              <template #title>
                <van-button size="small"
                            :icon="whichTree == 'employee' ? 'user-o' : 'manager-o'"
                            :type="whichTree == 'employee' ? 'warning' : 'primary'"></van-button>
                <span class="check_name">{{ it.keyname }}</span>
              </template>
            </van-cell>
          </div>
        </div>
        <!-- 其他树 -->
        <div v-else>
          <!-- 多选树 -->
          <div v-if="multiseltree">
            <van-cell class="parents_cell other_cell"
                      center
                      v-for="(item, index) in otherTreeList"
                      :key="index + item.keyname">
              <template #icon>
                <van-checkbox v-model="item.checked"
                              @click="tickParent(item)"
                              shape="square"></van-checkbox>
              </template>
              <template #title>
                <van-button size="small"
                            icon="cluster-o"
                            color="#1491f7"></van-button>
                <span class="check_name">{{ item.keyname }}</span>
              </template>
              <template #default>
                <div v-if="item.hasLower"
                     class="haveClo"
                     @click.stop="hasLower(item)">
                  <van-icon name="arrow-down" />
                  <span>下级</span>
                </div>
              </template>
            </van-cell>
          </div>
          <!-- 非多选树 -->
          <div v-else>
            <van-cell class="parents_cell other_cell"
                      center
                      v-for="(item, index) in otherTreeList"
                      :key="index + item.keyname"
                      @click="checkChild(item)">
              <template #title>
                <van-button size="small"
                            icon="cluster-o"
                            color="#1491f7"></van-button>
                <span class="check_name">{{ item.keyname }}</span>
              </template>
              <template #default>
                <div v-if="item.hasLower"
                     class="haveClo"
                     @click.stop="hasLower(item)">
                  <van-icon name="arrow-down" />
                  <span>下级</span>
                </div>
              </template>
            </van-cell>
          </div>
        </div>
      </div>
      <div class="tree_foot"
           v-if="multiseltree">
        <van-button type="primary"
                    size="small"
                    @click="cleanChecked">清除</van-button>
        <van-button type="info"
                    size="small"
                    :disabled="!canComfirm"
                    @click="comfirmChecked">确定</van-button>
      </div>
    </van-popup>

    <!-- 身份证照片识别弹窗 -->
    <van-popup class="idcard_popup"
               v-model="showIdCardPop"
               position="right"
               :style="{ width: '100%', height: '100%' }">
      <van-sticky class="title_div">
        <div class="title">
          <van-icon name="arrow-left"
                    @click="showIdCardPop = false" />
          身份证识别
        </div>
      </van-sticky>
      <div class="upload_idcard">
        <div class="card_po">
          <van-uploader v-model="idcardPofileList"
                        :max-count="1"
                        accept="image/*"
                        preview-size="100"
                        :after-read="afterReadPo" />
          <div style="font-size:14px;text-align: center;padding: 10px 0;">
            点击上传身份证人像面
          </div>
        </div>
        <div class="card_back">
          <van-uploader v-model="idcardBafileList"
                        :max-count="1"
                        accept="image/*"
                        preview-size="100"
                        :after-read="afterReadBa" />
          <div style="font-size:14px;text-align: center;padding: 10px 0;">
            点击上传身份证国徽面
          </div>
        </div>
      </div>
      <div class="idcard_form">
        <van-overlay :show="idcardFormLoading"
                     z-index="5000"
                     @click="idcardFormLoading = false">
          <van-loading size="24px"
                       vertical
                       color="#0094ff"
                       style="top:50%">加载中...</van-loading>
        </van-overlay>

        <van-form style="position:relative">
          <van-image width="100"
                     height="123"
                     radius="10"
                     :src="idcardForm.photo"
                     style="position: absolute;top: 15px;right: 10px;z-index: 2000;" />
          <van-field v-model="idcardForm.empname"
                     label="姓名"
                     placeholder="请输入" />
          <van-field v-model="idcardForm.sex"
                     label="性别"
                     readonly
                     placeholder="请选择"
                     @click="showSexPicker = true" />
          <van-popup v-model="showSexPicker"
                     position="bottom">
            <van-picker show-toolbar
                        :columns="['男', '女']"
                        @confirm="onSexConfirm"
                        @cancel="showSexPicker = false" />
          </van-popup>
          <van-field v-model="idcardForm.nation"
                     label="民族"
                     readonly
                     placeholder="请选择"
                     @click="showMzPic" />
          <van-popup v-model="showMzPicker"
                     position="bottom">
            <van-picker show-toolbar
                        :columns="mzColumns"
                        @confirm="onMzConfirm"
                        @cancel="showMzPicker = false" />
          </van-popup>
          <van-field v-model="idcardForm.birthday"
                     label="出生"
                     readonly
                     placeholder="请选择"
                     @click="showICDate('birthday')" />
          <van-field v-model="idcardForm.regplace"
                     label="住址"
                     placeholder="请输入" />
          <van-field v-model="idcardForm.idcardnum"
                     label="身份证号码"
                     placeholder="请输入" />
          <van-field v-model="idcardForm.regpolicestation"
                     label="签发机关"
                     placeholder="请输入" />
          <van-field v-model="idcardForm.idbd"
                     label="签发日期"
                     readonly
                     placeholder="请选择"
                     @click="showICDate('idbd')" />
          <van-field v-model="idcardForm.ided"
                     label="失效日期"
                     readonly
                     placeholder="请选择"
                     @click="showICDate('ided')" />

          <!-- 日期选择 -->
          <van-popup v-model="showICDatePicker"
                     position="bottom">
            <van-datetime-picker v-model="ICDate"
                                 type="date"
                                 title="选择年月日"
                                 :min-date="ICDateMinDate"
                                 :max-date="ICDateMaxDate"
                                 @confirm="onConfirmICDate"
                                 @cancel="showICDatePicker = false" />
          </van-popup>
        </van-form>
      </div>
      <div class="idcard_foot">
        <van-button type="info"
                    @click="saveIDcardInfo">保存身份证信息</van-button>
      </div>
    </van-popup>

    <!-- 银行卡识别弹窗 -->
    <van-popup class="idcard_popup"
               v-model="showBankCardPop"
               position="right"
               :style="{ width: '100%', height: '100%' }">
      <van-sticky class="title_div">
        <div class="title">
          <van-icon name="arrow-left"
                    @click="showBankCardPop = false" />
          银行卡识别
        </div>
      </van-sticky>
      <div class="upload_idcard">
        <div class="card_po bank_card">
          <van-uploader v-model="bankcardPofileList"
                        :max-count="1"
                        accept="image/*"
                        preview-size="200"
                        :after-read="afterReadBankCardPo" />
          <div style="font-size:14px;text-align: center;padding: 10px 0;">
            点击上传银行卡照片
          </div>
        </div>
      </div>
      <div class="idcard_form bankCard_form">
        <van-overlay :show="idcardFormLoading"
                     z-index="5000"
                     @click="idcardFormLoading = false">
          <van-loading size="24px"
                       vertical
                       color="#0094ff"
                       style="top:50%">加载中...</van-loading>
        </van-overlay>
        <van-form style="position:relative">
          <van-field v-model="bankCardForm.bankaccount"
                     label="银行卡卡号"
                     placeholder="请输入" />
          <van-field v-model="bankCardForm.endDate"
                     label="有效期"
                     placeholder="请输入" />
          <van-field v-model="bankCardForm.bankname"
                     label="银行名称"
                     placeholder="请输入" />
          <van-field v-model="bankCardForm.cardType"
                     label="银行卡类型"
                     placeholder="请输入" />
        </van-form>
      </div>
      <div class="idcard_foot">
        <van-button type="info"
                    @click="saveBankCardInfo">保存银行卡信息</van-button>
      </div>
    </van-popup>
  </div>
</template>
<script>
import { Base64 } from 'js-base64'
import { areaList } from '@vant/area-data'
// import 'vant/lib/datetime-picker/style'
// import 'vant/lib/picker/style'
// import 'vant/lib/popup/style'
// import 'vant/lib/uploader/style'
// import 'vant/lib/image/style'
// import 'vant/lib/Notify/style'
import {
  Popup,
  DatetimePicker,
  Picker,
  Uploader,
  Notify,
  Dialog
  // Image
} from 'vant'
import Compressor from 'compressorjs'
import { parseTime, hex2int, int2hex } from '@/utils'
import {
  upLoadFile,
  GetFormFieldDetail,
  GetFilterDropDownList,
  GetFormFieldExitValue,
  GetFormFieldExitInfo,
  GetCustomQueryInfo,
  GetFormNewDefaultValue,
  getEmpInfo,
  GetBeforeActionList,
  ProcessBeforeAction,
  PostModuleRecord,
  ProcessAfterAction,
  GetFormRecordData,
  getmoduleattfilelist,
  deleteFile,
  getDownLoadFileName,
  saveQsTemplateOptionList,
  getCommTreeData,
  upLoadBase64File,
  upLoadBase64FileFixName,
  saveRsTempRecord,
  getIdCardFrontInfo,
  getIdCardBackInfo,
  beforePostIdCardInfo,
  updateWxEmpDetail,
  getBankCardInfo
} from '@/request/api.js'
export default {
  name: 'wxForm',
  components: {
    'van-datetime-picker': DatetimePicker,
    'van-picker': Picker,
    'van-popup': Popup,
    'van-uploader': Uploader
    // 'van-image': Image
  },
  props: {
    // 基本信息
    moduleConfig: {
      type: Object,
      default: () => { }
    },
    // 模块号
    moduleno: {
      type: [String, Number],
      default: ''
    },
    // // 表单状态（save:新增,modify:修改,readonly:只读）
    status: {
      type: String,
      default: 'save'
    },
    // 记录状态（save:新增,modify:修改,readonly:只读  优先度高于status）
    saveormodify: {
      type: String,
      default: 'save'
    },
    acceptid: {
      // 当前记录autoid
      type: [String, Number],
      default: 0
    },
    localempid: {
      // 当前记录empid
      type: [String, Number],
      default: 0
    },
    sqnum: {
      // 当前子表的序号
      type: [String, Number],
      default: null
    },
    // 主表formstr
    masterformstr: {
      type: String,
      default: ''
    },
    // 当前表单来自（1：主表，4- ：子表，5- ：附表）
    masterisactive: {
      type: String,
      default: '1'
    },
    // 登录方式（true：手机，false:非手机）
    mode: {
      type: String,
      default: 'false'
    },
    // 手机
    tel: {
      type: String,
      default: ''
    },
    // 招聘渠道
    restype: {
      type: String,
      default: ''
    },
    // 接收父辈的字段
    treeNodePre: {
      type: Object,
      default: () => { }
    },
    // 是否启用分页
    pageshow: {
      type: [String, Number],
      default: 0
    },
    // 是否是子表
    isSon: {
      type: Boolean,
      default: false
    },
    // 子表的附件名列表
    detailAtList: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      areaList, // Vant 官方提供了一份默认的中国省市区数据，可以通过 @vant/area-data 引入：
      sq: 1, //保存问卷几次
      submmited_qs: null, // 是否提交了问卷
      tj_empid: '',
      zpacid: '',
      autoid: 0,
      paperid: 0, //问卷id
      userInfo: { username: 'admin', userid: 1 }, // 用户登录信息
      attachfilepath: 'AttachFile',
      Selectformdata: {}, // 选中的字段（用于接收弹窗返回信息）
      formstr: {}, // 保存表单填写数据
      logdetail: '', // 有修改的字段
      customQueryForminfo: {}, //自定义窗体-构造查询窗体信息
      customQueryQueryparaminfo: [], //自定义窗体-构造顶部查询条件
      singleSel: true, // 是否单选（多选需要处罚批量添加记录）
      fieldlist: [], // 生成表单接口相关数据
      choices: [], // 下拉框选项
      hasEXfieldlist: [], // 当前数据带出链已经带出过的字段
      keycode: 0, // 键盘key
      intarry: ['int', 'smallint'], // sql整数类型
      floatarry: ['money', 'float', 'numeric'], // sql小数类型
      datetime: ['datetime', 'smalldatetime'], // sql时间类型
      empcodeData: [], //工号字段输入姓名自动转化后，多笔数据
      active: '', // 当前要打开的弹窗 组件
      gressDialog: false,
      gressDialogConnect: '',
      gressIdx: 0,
      progress: 0,
      total: 0, // 进度条 总数
      strinfo: '',
      new_acceptid: this.acceptid,
      new_saveormodify: this.saveormodify,
      new_status: this.status,
      form: {
        loopData: []
      },
      showPicker: false,
      showDtPicker: false,
      currentDate: new Date(),
      fileList: [],
      fileList2: [],
      minDate: this.dd('min'),
      maxDate: this.dd('max'),
      showTreePop: false, // 树弹窗显示
      whichTree: '', // 树类型
      searchTreeVal: '', // 树弹窗搜索词
      allTreeList: [], // 所有树集合
      parentTreeList: [], // 上级树集合（针对岗位树和员工数）
      childsTreeList: [], // 下级树集合（针对岗位树和员工数）
      clickParentTree: [], // 储存点击过的父节点
      otherTreeList: [], // 其他类型树集合
      multiseltree: false, // 是否是多选树
      canComfirm: false, // 多选树确定按钮是否可以点击
      seStaList: ['304', '317', '319'],
      inputControltype: ['edit', 'memo'],
      inputControltype2: [
        'edit',
        'memo',
        'combobox',
        'lookupcombobox',
        'datetime',
        'longdatetime'
        // 'maskedit'
      ],
      showEmppic: true, //是否显示附件（指定名称）
      singleCroList: [], // 用来控制每一个分组的显示
      showAppendix: false, // 是否显示附件信息
      showCanSave: true, // 是否显示保存前提示
      usepresign: false, // 是否启用提交签名弹窗（配置文件）
      usedicfilename: false, // 允许主表附加字典类别显示；（1允许，0不允许）（配置文件）
      masterAtFileList: [],
      otherAtFileList: '',
      useMasterAtFile: false, // 表示允许字典附件在某个主表后显示；(前提是usedicfilename=1)
      showCitySelector: false, // 是否显示省市区选择器弹窗
      storageSbject: {}, // 当后台控件类型controltype=maskedit 并且maskeditstr=CitySelector时，选择省份、城市、镇区的联动选择接受的储存中间对象
      sonAtList: [], // 初始的子表的附件列表
      showIdCardPop: false, // 身份证识别弹窗
      idcardPofileList: [],
      idcardBafileList: [],
      idcardForm: {
        empname: '',
        sex: '',
        nation: '',
        birthday: '',
        regplace: '',
        idcardnum: '',
        photo: '',
        regpolicestation: '',
        idbd: '',
        ided: ''
      },
      idcardFormLoading: false,
      showSexPicker: false,
      showMzPicker: false,
      mzColumns: [],
      showICDatePicker: false,
      ICDate: new Date(),
      ICDateMinDate: new Date(1900, 0, 1),
      ICDateMaxDate: new Date(2200, 12, 1),
      choiceICDate: '',
      use_identify_ocr: true, // 是否显示身份证识别按钮
      hide_all_master_atfile: false, // 隐藏所有主表的附件信息,
      hide_all_detail_atfile: false, // 隐藏所有子表的附件信息
      can_not_del_master_file: false, // 不允许删除主表附件
      can_not_del_detail_file: false, // 不允许删除子表附件
      can_not_change_master_file: false, // 不允许更换主表附件
      can_not_change_detail_file: false, // 不允许更换子表附件
      use_bank_ocr: false, // 是否银行卡识别
      bank_orc_bankaccount_field: '', // 银行卡号字段名
      bank_orc_bankname_field: "", // 开户行名称字段名
      showBankCardPop: false, // 银行卡识别弹窗
      bankCardForm: {
        bankaccount: '',
        endDate: '',
        bankname: '',
        cardType: ''
      },
      bankcardPofileList: []
    }
  },
  computed: {
    // 保存前是否签名
    pcuserinfo () {
      let str = ''
      if (this.moduleno == 240)
      {
        str = 'system_wx_' + this.moduleno
        if (this.restype)
        {
          // 区域招聘
          str = 'system_' + this.restype
        }
      } else if (this.seStaList.includes(this.moduleno))
      {
        str = 'system_wx_' + this.moduleno + '_' + this.restype
      }
      return str
    },
    // 隐藏附件
    showAtfile () {
      if (this.isSon)
      {
        let params = this.$route.query.param || {}
        if (Object.keys(params).length > 0)
        {
          params = JSON.parse(Base64.decode(params))
        }
        let m_moduleno = params.module // 主表模块号 
        let mparams = window['m' + m_moduleno]
        let hide_one_detail_atfile = 0
        if (mparams)
        {
          hide_one_detail_atfile = mparams['m' + this.moduleno + '_hide_detail_atfile'] ? mparams['m' + this.moduleno + '_hide_detail_atfile'] : 0
        }
        return !this.hide_all_detail_atfile && hide_one_detail_atfile != 1
      } else
      {
        return !this.hide_all_master_atfile
      }
    },
    // 不允许删除附件
    notDeleteAtfile () {
      if (this.isSon)
      {
        return this.can_not_del_detail_file
      } else
      {
        return this.can_not_del_master_file
      }
    },
    // 不允许更换附件
    notChangeAtfile () {
      if (this.isSon)
      {
        return this.can_not_change_detail_file
      } else
      {
        return this.can_not_change_master_file
      }
    }
  },
  watch: {
    showIdCardPop (n) {
      if (!n)
      {
        this.idcardPofileList = []
        this.idcardBafileList = []
        this.idcardForm = {
          empname: '',
          sex: '',
          nation: '',
          birthday: '',
          regplace: '',
          idcardnum: '',
          photo: '',
          regpolicestation: '',
          idbd: '',
          ided: ''
        }
      }
    },
    showBankCardPop (n) {
      if (!n)
      {
        this.bankcardPofileList = []
        this.bankCardForm = {
          bankaccount: '',
          endDate: '',
          bankname: '',
          cardType: ''
        }
      }
    },
    acceptid: {
      handler (n) {
        // console.log(n,'acceptid1');

        this.new_acceptid = n
      },
      deep: true,
      immediate: true
    },
    moduleConfig: {
      handler (n) {
        setTimeout(() => {
          this.new_acceptid = this.acceptid
          // console.log(this.acceptid,'acceptid2');
          this.new_saveormodify = this.saveormodify
          this.new_status = this.status
          this.new_status = this.new_saveormodify
          // console.log(this.moduleConfig)
          if (this.new_saveormodify !== 'readonly')
          {
            const setfocusfield = this.moduleConfig.setfocusfield
            this.$nextTick(function () {
              //2020-09-15 判断不是日期控件才定位
              this.form.loopData.forEach(it => {
                it.forEach(list => {
                  if (
                    (list.controltype === 'edit' ||
                      (list.controltype === 'combobox' && list.showpopquery) ||
                      (list.controltype === 'combobox' &&
                        list.ispoptree &&
                        list.poptreename != 'emptree') ||
                      (list.controltype === 'combobox' &&
                        list.ispoptree &&
                        list.poptreename === 'emptree') ||
                      list.controltype === 'maskedit' ||
                      list.controltype === 'memo') &&
                    list.fieldname === setfocusfield
                  )
                  {
                    if (this.$refs[setfocusfield])
                    {
                      this.$refs[setfocusfield][0].focus()
                    }
                  }
                })
              })
            })
          }
        }, 500)
        const keys = Object.keys(n)
        if (keys.length > 0)
        {
          this.getFormField()
        }
      },
      deep: true,
      immediate: true
    },
    saveormodify (n) {
      this.new_saveormodify = n
      this.new_status = n
    },
    status (n) {
      this.new_status = n
    },
    showTreePop (n) {
      if (n == false)
      {
        this.parentTreeList = [] // 上级树集合
        this.childsTreeList = [] // 子节点
        this.clickParentTree = [] // 点击过的父节点
        this.otherTreeList = [] // 其他树节点
        this.searchTreeVal = ''
      }
    },
    allTreeList: {
      handler (n) {
        let array = n.filter(ele => {
          return ele.checked == true
        })
        if (array.length > 0)
        {
          this.canComfirm = false
          if (this.whichTree == 'station')
          {
            for (let i = 0; i < array.length; i++)
            {
              const it = array[i]
              if (it.issta == true)
              {
                this.canComfirm = true
                return
              }
            }
          } else if (this.whichTree == 'employee')
          {
            for (let l = 0; l < array.length; l++)
            {
              const item = array[l]
              if (item.isdept == 0 && item.levelid == 16)
              {
                this.canComfirm = true
                return
              }
            }
          } else
          {
            // 其他树
            this.canComfirm = true
          }
        } else
        {
          this.canComfirm = false
        }
      },
      deep: true
    }
  },
  created () {
    // 获取路由参数
    let params = this.$route.query.param || {}
    if (Object.keys(params).length > 0)
    {
      params = JSON.parse(Base64.decode(params))
    }
    this.submmited_qs = params.submmited_qs
    this.tj_empid = params.tj_empid
    this.zpacid = params.zpacid
    this.autoid = params.autoid
    this.paperid = params.paperid
    this.attachfilepath = params.attachfilepath ? params.attachfilepath : 'AttachFile'
    let moduleno = params.module

    // 判断各模块的参数获取
    if (isNaN(Number(moduleno)))
    {
      // 不是数字
      // 是否显示身份证识别按钮
      const mcommuse_identify_ocr = window.comm
        ? window.comm.use_identify_ocr
        : ''
      if (mcommuse_identify_ocr == 1 && !this.isSon)
      {
        this.use_identify_ocr = true
      } else
      {
        this.use_identify_ocr = false
      }
      //如果show_identify_first为1表示登录后强制弹出身份证识别窗体识别后才能进去下个界面
      const show_identify_first = window.comm
        ? window.comm.show_identify_first
        : ''
      if (show_identify_first == 1 && !this.isSon && this.mode != 'false')
      {
        this.showIdCardPop = true
      } else
      {
        this.showIdCardPop = false
      }
      const mcommusepresign = window.comm ? window.comm.usepresign : ''
      if (mcommusepresign == 1)
      {
        this.usepresign = true
      } else
      {
        this.usepresign = false
      }
      const ud = window.comm ? window.comm.usedicfilename : ''
      if (ud == 1 && !this.isSon)
      {
        this.usedicfilename = true
      } else
      {
        this.usedicfilename = false
      }
      const uma = window.comm ? window.comm.useMasterAtFile : ''
      if (uma == 1 && !this.isSon)
      {
        this.useMasterAtFile = true
      } else
      {
        this.useMasterAtFile = false
      }
      this.masterAtFileList = window.comm ? window.comm.masterAtFileList : []
      this.otherAtFileList = window.comm ? window.comm.otherAtFileList : ''
      // 是否隐藏主表或者子表附件
      const hama = window.comm ? window.comm.hide_all_master_atfile : ''
      if (hama == 1)
      {
        this.hide_all_master_atfile = true
      } else
      {
        this.hide_all_master_atfile = false
      }
      const hada = window.comm ? window.comm.hide_all_detail_atfile : ''
      if (hada == 1)
      {
        this.hide_all_detail_atfile = true
      } else
      {
        this.hide_all_detail_atfile = false
      }
      // 不允许删除主表/子表附件
      const delMFile = window.comm ? window.comm.can_not_del_master_file : ''
      if (delMFile == 1)
      {
        this.can_not_del_master_file = true
      } else
      {
        this.can_not_del_master_file = false
      }
      const delDFile = window.comm ? window.comm.can_not_del_detail_file : ''
      if (delDFile == 1)
      {
        this.can_not_del_detail_file = true
      } else
      {
        this.can_not_del_detail_file = false
      }
      // 不允许更换主表/子表附件
      const changeMFile = window.comm ? window.comm.can_not_change_master_file : ''
      if (changeMFile == 1)
      {
        this.can_not_change_master_file = true
      } else
      {
        this.can_not_change_master_file = false
      }
      const changeFile = window.comm ? window.comm.can_not_change_detail_file : ''
      if (changeFile == 1)
      {
        this.can_not_change_detail_file = true
      } else
      {
        this.can_not_change_detail_file = false
      }
      // 是否银行卡识别
      const use_bank_ocr = window.comm ? window.comm.use_bank_ocr : ''
      if (changeFile == 1)
      {
        this.use_bank_ocr = true
      } else
      {
        this.use_bank_ocr = false
      }
      this.bank_orc_bankaccount_field = window.comm ? window.comm.bank_orc_bankaccount_field : '' // 银行卡号字段名
      this.bank_orc_bankname_field = window.comm ? window.comm.bank_orc_bankname_field : ''
    } else
    {
      // 是数字
      // 是否显示身份证识别按钮
      const muse_identify_ocr = window['m' + moduleno]
        ? window['m' + moduleno].use_identify_ocr
        : ''
      if (muse_identify_ocr == 1 && !this.isSon)
      {
        this.use_identify_ocr = true
      } else
      {
        this.use_identify_ocr = false
      }
      //如果show_identify_first为1表示登录后强制弹出身份证识别窗体识别后才能进去下个界面
      const show_identify_first = window['m' + moduleno]
        ? window['m' + moduleno].show_identify_first
        : ''
      console.log(this.mode, 'this.mode ');
      if (show_identify_first == 1 && !this.isSon && this.mode != 'false')
      {
        this.showIdCardPop = true
      } else
      {
        this.showIdCardPop = false
      }
      const musepresign = window['m' + moduleno]
        ? window['m' + moduleno].usepresign
        : ''
      if (musepresign == 1)
      {
        this.usepresign = true
      } else
      {
        this.usepresign = false
      }
      const ud = window['m' + moduleno]
        ? window['m' + moduleno].usedicfilename
        : ''
      if (ud == 1 && !this.isSon)
      {
        this.usedicfilename = true
      } else
      {
        this.usedicfilename = false
      }
      const uma = window['m' + moduleno]
        ? window['m' + moduleno].useMasterAtFile
        : ''
      if (uma == 1 && !this.isSon)
      {
        this.useMasterAtFile = true
      } else
      {
        this.useMasterAtFile = false
      }
      this.masterAtFileList = window['m' + moduleno]
        ? window['m' + moduleno].masterAtFileList
        : []
      this.otherAtFileList = window['m' + moduleno]
        ? window['m' + moduleno].otherAtFileList
        : ''
      // 是否隐藏主表或者子表附件
      const hama = window['m' + moduleno]
        ? window['m' + moduleno].hide_all_master_atfile
        : ''
      if (hama == 1)
      {
        this.hide_all_master_atfile = true
      } else
      {
        this.hide_all_master_atfile = false
      }
      const hada = window['m' + moduleno]
        ? window['m' + moduleno].hide_all_detail_atfile
        : ''
      if (hada == 1)
      {
        this.hide_all_detail_atfile = true
      } else
      {
        this.hide_all_detail_atfile = false
      }
      // 不允许删除主表/子表附件
      const delMFile = window['m' + moduleno] ? window['m' + moduleno].can_not_del_master_file : ''
      if (delMFile == 1)
      {
        this.can_not_del_master_file = true
      } else
      {
        this.can_not_del_master_file = false
      }
      const delDFile = window['m' + moduleno] ? window['m' + moduleno].can_not_del_detail_file : ''
      if (delDFile == 1)
      {
        this.can_not_del_detail_file = true
      } else
      {
        this.can_not_del_detail_file = false
      }
      // 不允许更换主表/子表附件
      const changeMFile = window['m' + moduleno] ? window['m' + moduleno].can_not_change_master_file : ''
      if (changeMFile == 1)
      {
        this.can_not_change_master_file = true
      } else
      {
        this.can_not_change_master_file = false
      }
      const changeFile = window['m' + moduleno] ? window['m' + moduleno].can_not_change_detail_file : ''
      if (changeFile == 1)
      {
        this.can_not_change_detail_file = true
      } else
      {
        this.can_not_change_detail_file = false
      }
      // 是否银行卡识别
      const use_bank_ocr = window['m' + moduleno] ? window['m' + moduleno].use_bank_ocr : ''
      if (use_bank_ocr == 1)
      {
        this.use_bank_ocr = true
      } else
      {
        this.use_bank_ocr = false
      }
      this.bank_orc_bankaccount_field = window['m' + moduleno] ? window['m' + moduleno].bank_orc_bankaccount_field : '' // 银行卡号字段名
      this.bank_orc_bankname_field = window['m' + moduleno] ? window['m' + moduleno].bank_orc_bankname_field : ''
    }

    // 如果子表的附件有命名
    if (this.isSon == true && this.detailAtList.length > 0)
    {
      this.detailAtList.forEach(it => {
        if (it.dt_moduleno == this.moduleno)
        {
          const maList = it.dicname.split(',')
          // 加载附件名
          let tempdata = []
          //普通下拉框只取第一个属性值，并且明明为dicvalue
          maList.forEach(item => {
            tempdata.push({
              url: null,
              name: item,
              file: null,
              type: 'no',
              readonly: false
            })
          })
          this.fileList = tempdata
          this.sonAtList = tempdata
        }
      })
      // console.log(this.fileList, '你他吗的字符串不行？');
      // this.fileList = JSON.parse(JSON.stringify(this.saveSonFileLiost))
      this.$forceUpdate()
    }
  },
  mounted () {
    // console.log(666666, this.new_status, this.new_saveormodify)
    //打开是focus定位字段
    setTimeout(() => {
      this.new_acceptid = this.acceptid
      //  console.log(this.acceptid,'acceptid3');
      this.new_saveormodify = this.saveormodify
      this.new_status = this.status
      this.new_status = this.new_saveormodify
      if (this.new_saveormodify !== 'readonly')
      {
        const setfocusfield = this.moduleConfig.setfocusfield
        this.$nextTick(function () {
          //2020-09-15 判断不是日期控件才定位
          this.form.loopData.forEach(it => {
            it.forEach(list => {
              if (
                (list.controltype === 'edit' ||
                  (list.controltype === 'combobox' && list.showpopquery) ||
                  (list.controltype === 'combobox' &&
                    list.ispoptree &&
                    list.poptreename != 'emptree') ||
                  (list.controltype === 'combobox' &&
                    list.ispoptree &&
                    list.poptreename === 'emptree') ||
                  list.controltype === 'maskedit' ||
                  list.controltype === 'memo') &&
                list.fieldname === setfocusfield
              )
              {
                if (this.$refs[setfocusfield])
                {
                  this.$refs[setfocusfield][0].focus()
                }
              }
            })
          })
        })
      }
      // 只允许主表附加字典类别显示 不允许字典附件在某个主表后显示
      if (this.usedicfilename && !this.useMasterAtFile)
      {
        // this.comboboxNoispoptreefocus('@扫码登记简历附件类别', 'filse', {
        //   chnname: '附件名称'
        // })
        this.getOtherFileList()
      } else if (this.usedicfilename && this.useMasterAtFile)
      {
        // 在请求构造表单时处理主表分隔线后的附件
        // 如果 otherAtFileList 还有设置的话，就全部显示到最后的附件位置；
        this.getOtherFileList()
      }

      // 假如没有启用分页，则显示附件
      if ((this.pageshow != 1 || this.pageshow != '1') && !this.isSon)
      {
        this.showAppendix = true
      }
    }, 500)
  },
  methods: {
    // 识别银行卡
    afterReadBankCardPo (file) {
      const ext = file.file.type ? file.file.type.split('/')[1] : 'png'
      this.idcardFormLoading = true
      let base64 = file.content
      if (base64)
      {
        getBankCardInfo({
          photo: base64
        }).then(res => {
          if (res.data.length > 0)
          {
            this.bankCardForm.bankaccount = res.data[0].bankaccount
            this.bankCardForm.bankname = res.data[0].bankname
          }
        }).finally(() => {
          this.idcardFormLoading = false
        })
      } else
      {
        this.idcardFormLoading = false
      }
    },
    // 保存银行卡信息
    saveBankCardInfo () {
      if (this.bankCardForm.bankaccount)
      {
        this.setValue(this.bank_orc_bankaccount_field, this.bankCardForm.bankaccount, 'old')
      }
      if (this.bankCardForm.bankname)
      {
        this.setValue(this.bank_orc_bankname_field, this.bankCardForm.bankname, 'old')
      }
      this.showBankCardPop = false
    },
    afterReadAttr (file) {
      console.log(file, 'filefile')
      file.status = 'uploading'
      file.message = '上传中...'

      this.upLoadBase64(
        file.file,
        file.name ? file.name + '.' + file.ext : null
      ).then(res => {
        if (res == 'OK')
        {
          file.status = 'done'
        } else
        {
          file.status = 'failed'
          file.message = '上传失败'
          // this.$message({ type: 'error', message: res })
          Notify({
            type: 'danger',
            message: res
          })
        }
      })
    },
    // 身份日期show
    showICDate (val) {
      this.showICDatePicker = true
      this.choiceICDate = val
    },
    // 身份日期选中
    onConfirmICDate (val) {
      let da = parseTime(val, '{y}-{m}-{d}')
      if (this.choiceICDate == 'birthday')
      {
        this.idcardForm.birthday = da
      } else if (this.choiceICDate == 'idbd')
      {
        this.idcardForm.idbd = da
      } else if (this.choiceICDate == 'ided')
      {
        this.idcardForm.ided = da
      }
      this.showICDatePicker = false
    },
    // 选择名族
    showMzPic () {
      GetFilterDropDownList({
        moduleno: this.moduleno,
        username: this.userInfo.username,
        listsql: '@民族'
      }).then(res => {
        this.mzColumns = res.data.map(it => {
          return it.dicvalue
        })
      })
      this.showMzPicker = true
    },
    // 名族选中
    onMzConfirm (val) {
      this.idcardForm.nation = val
      this.showMzPicker = false
    },
    // 身份证识别--性别
    onSexConfirm (val) {
      this.idcardForm.sex = val
      this.showSexPicker = false
    },
    // {身份证、手机号}输入框失去焦点
    blurSomeField (fieldname, formdata) {
      if (fieldname == 'idcardnum' || fieldname == 'telephone')
      {
        this.getBeforePostIdCardInfo(fieldname, formdata).then(res => {
          let result = res
        })
      }
    },
    // 扫码入职保存或退出身份证号码时触发的接口
    getBeforePostIdCardInfo (fieldname, fieldvalue) {
      return new Promise((resolve, reject) => {
        beforePostIdCardInfo({
          autoid: this.new_acceptid,
          moduleno: this.moduleno,
          fieldname: fieldname,
          fieldvalue: fieldvalue
        }).then(res => {
          let result = res.data[0]
          if (result.isinfo)
          {
            if (result.cansave)
            {
              // 当 cansave=true 弹窗提示 info 的内容并询问“是”或“否”，点“是”调接口api/wx/updateWxEmpDetail后
              Dialog.confirm({
                message: result.info
              })
                .then(() => {
                  // on confirm
                  updateWxEmpDetail({
                    autoid: this.new_acceptid,
                    moduleno: this.moduleno,
                    fieldname: fieldname,
                    fieldvalue: fieldvalue
                  }).then(res => {
                    if (res.data[0].info != '')
                    {
                      Toast.fail(res.data[0].info)
                    } else
                    {
                      // 要刷新子表信息
                      this.$emit('refreshSonData')
                    }
                    resolve({ closeDia: true, setVal: true, exitVal: true })
                  })
                })
                .catch(() => {
                  // on cancel
                  resolve({ closeDia: true, setVal: true, exitVal: false })
                })
            } else
            {
              // 当 cansave=false 弹窗提示 info 的内容，点确定后继续停留在身份识别界面
              Dialog.alert({
                message: result.info
              }).then(() => {
                // on close
                resolve({ closeDia: false, setVal: false, exitVal: false })
              })
            }
          } else
          {
            // 当isinfo=false 无需任何提示，直接返回
            resolve({ closeDia: true, setVal: true, exitVal: true })
          }
        })
      })
    },
    // 保存身份证信息
    saveIDcardInfo () {
      this.getBeforePostIdCardInfo('idcardnum', this.idcardForm.idcardnum).then(
        res => {
          let result = res
          // console.log(result, 'resultresult');
          if (result.closeDia)
          {
            this.showIdCardPop = false
          }
          let keys = Object.keys(this.idcardForm)
          keys.forEach(item => {
            if (this.idcardForm[item])
            {
              if (result.setVal)
              {
                this.setValue(item, this.idcardForm[item], 'old')
              }
              if (result.exitVal)
              {
                this.form.loopData.forEach(it => {
                  it.forEach(i => {
                    if (i.fieldname === item && i.isexitvalue)
                    {
                      //启用数据带出
                      this.bulidExitValue(
                        item,
                        this.idcardForm[item],
                        this.ExitValue
                      )
                    }
                  })
                })
              }
            }
          })
        }
      )
    },
    // 识别身份证正面
    afterReadPo (file) {
      const ext = file.file.type ? file.file.type.split('/')[1] : 'png'
      this.idcardFormLoading = true
      let base64 = file.content
      if (base64)
      {
        getIdCardFrontInfo({
          photo: base64,
          autoid: this.new_acceptid,
          moduleno: this.moduleno
        })
          .then(res => {
            if (res.data.length > 0)
            {
              this.idcardForm.empname = res.data[0].empname
              this.idcardForm.sex = res.data[0].sex
              this.idcardForm.nation = res.data[0].nation
              this.idcardForm.birthday = res.data[0].birthday
              this.idcardForm.regplace = res.data[0].regplace
              this.idcardForm.idcardnum = res.data[0].idcardnum
              this.idcardForm.photo = res.data[0].photo ? 'data:image/' + ext + ';base64,' + res.data[0].photo : ''
              // 2023-07-29 先注释身份证识别后的文件储存----2023/10/13又改回来
              /*
              ? 'data:image/' + ext + ';base64,' + res.data[0].photo
              : ''
            // 将头像传给头像证件照
            this.$emit('setIDCardphoToPic', this.idcardForm.photo)
             */
              // 如果开启自定义附件
              if (this.usedicfilename)
              {
                // 有身份证的话就赋值给身份证 
                let finalFile = null
                let url = require('@/assets/img/idcard_zhengmian.png')
                // 假如没有启用分页
                if (this.pageshow != 1 || this.pageshow != '1')
                {
                  url = base64
                  finalFile = this.reFileName(file.file, '身份证正面照片.' + ext)
                } else
                {
                  url = require('@/assets/img/idcard_zhengmian.png')
                  finalFile = null
                }
                this.fileList.forEach(it => {
                  if (it.name == '身份证正面照片')
                  {
                    it.type = "身份证正面照片"
                    it.url = url
                    it.isImage = true
                    it.ext = ext
                    it.file = finalFile
                    it.readonly = true
                    // it.file = this.reFileName(file.file, it.name + '.' + ext)
                  }
                })
              }

              // this.idcardFormLoading = false
            }
          })
          .finally(() => {
            this.idcardFormLoading = false
          })
      } else
      {
        this.idcardFormLoading = false
      }
    },
    // 识别身份证反面
    afterReadBa (file) {
      const ext = file.file.type ? file.file.type.split('/')[1] : 'png'
      this.idcardFormLoading = true
      let base64 = file.content
      if (base64)
      {
        getIdCardBackInfo({
          photo: base64,
          autoid: this.new_acceptid,
          moduleno: this.moduleno
        })
          .then(res => {
            if (res.data.length > 0)
            {
              this.idcardForm.regpolicestation = res.data[0].regpolicestation
              this.idcardForm.idbd = res.data[0].idbd
              if (res.data[0].ided && isNaN(res.data[0].ided) && !isNaN(Date.parse(res.data[0].ided)))
              {
                this.idcardForm.ided = res.data[0].ided
              } else
              {
                this.idcardForm.ided = ''
              }
              // 2023-07-29 先注释身份证识别后的文件储存
              let finalFile = null
              let url = require('@/assets/img/idcard_fanmian.png')
              // 如果开启自定义附件
              if (this.usedicfilename)
              {
                // 假如没有启用分页
                if (this.pageshow != 1 || this.pageshow != '1')
                {
                  url = base64
                  finalFile = this.reFileName(file.file, '身份证背面照片.' + ext)
                } else
                {
                  url = require('@/assets/img/idcard_fanmian.png')
                  finalFile = null
                }
                // 有身份证的话就赋值给身份证
                this.fileList.forEach(it => {
                  if (it.name == '身份证背面照片')
                  {
                    it.type = '身份证背面照片'
                    it.url = url
                    it.isImage = true
                    it.ext = ext
                    it.file = finalFile
                    it.readonly = true

                    // it.file = this.reFileName(file.file, it.name + '.' + ext)
                  }
                })
              }
              // this.idcardFormLoading = false
            }
          })
          .finally(() => {
            this.idcardFormLoading = false
          })
      } else
      {
        this.idcardFormLoading = false
      }
    },
    // 身份证号码点击
    showIdCardDia (item) {
      this.showIdCardPop = true
    },
    // 银行卡识别
    showBankCardDia (item) {
      this.showBankCardPop = true
    },
    // 点击下一步或上一步（或左边切换）时保存数据接口
    saveRsTempRecordData () {
      this.updateformstr()
      const editstate =
        this.new_acceptid === '' ||
          this.new_acceptid === null ||
          this.new_acceptid === '0' ||
          this.new_acceptid === 0
          ? 1
          : 2
      if (editstate === 2)
      {
        this.formstr.autoid = this.new_acceptid
      }
      this.formstr[this.mkeyname] = this.new_acceptid //更新主键
      // 处理formstr数字转换成字符
      for (const key in this.formstr)
      {
        if (!isNaN(this.formstr[key]))
        {
          this.formstr[key] = String(this.formstr[key])
        }
      }
      let userName = 'system_wx'
      if (this.moduleno == 240)
      {
        this.formstr.crman = this.pcuserinfo
        userName = this.pcuserinfo
      } else if (this.moduleno == 317)
      {
        // this.formstr.crman = 'system_lt'
        userName = 'system_lt'
      } else if (this.moduleno == 319)
      {
        // this.formstr.crman = 'system_xy'
        userName = 'system_xy'
      } else if (this.moduleno == 304)
      {
        // this.formstr.crman = 'system_wx'
        userName = 'system_wx'
        this.formstr.tj_empid = this.tj_empid
      } else if (this.moduleno == 322)
      {
        // this.formstr.crman = 'system_wx'
        userName = 'system_pq'
      } else
      {
        // this.formstr.crman = 'system_wx'
        userName = 'system_wx'
      }
      if (this.zpacid)
      {
        // 如下图，招聘活动的二维码地址格式，针对moduleno=319并且地址参数传了zpacid的值（这个是招聘活动id），在最后保存简历时api/wx/postModuleRecord，要给formstr 传入 zpacid这个参数；
        this.formstr.zpacid = this.zpacid
      }
      // 需要去除ispost属性
      delete this.formstr.ispost
      console.log(this.formstr, 'this.formstr')
      saveRsTempRecord({
        moduleno: this.moduleno,
        editstate: editstate,
        // pcuserinfo: this.pcuserinfo, // 用户名称,
        pcuserinfo: userName,
        formstr: JSON.stringify(this.formstr),
        logdetail: this.logdetail
      })
        .then(res => {
          const data = res.data[0]
          if (res.iserror == '0' && !data.info)
          {
            if (this.singleSel)
            {
              if (editstate === 1)
              {
                // console.log(editstate)

                this.new_acceptid = data.insid
                //  console.log(data.insid,'acceptid4');
                this.setValue(this.mkeyname, this.new_acceptid)
                // this.$message({ type: 'success', message: '保存成功' })
                // 保存问卷
                if (
                  (this.submmited_qs == true || this.submmited_qs == 'true') &&
                  this.sq == 1
                )
                {
                  // 保存问卷
                  this.saveQsTemplateOptionList()
                  this.sq++
                }
              } else
              {
                // this.$message({ type: 'success', message: '修改成功' })
              }
            }

            // // 保存附件
            // let fileAry = []
            // // 允许主表附加字典类别显示 允许字典附件在某个主表后显示
            // // 把每个分隔线后的附件遍历上传
            // if (this.usedicfilename && this.useMasterAtFile)
            // {
            //   this.form.loopData.forEach(ld => {
            //     if (ld.fileList)
            //     {
            //       ld.fileList.forEach(it => {
            //         fileAry.push(it)
            //       })
            //     }
            //   })
            // }
            // this.fileList.forEach(f => {
            //   fileAry.push(f)
            // })

            // // 上传附件
            // let num = 0
            // fileAry.forEach((f, index) => {
            //   if (!f.type)
            //   {
            //     f.status = 'uploading'
            //     f.message = '上传中...'

            //     this.upLoadBase64(
            //       f.file,
            //       f.name ? f.name + '.' + f.ext : null
            //     ).then(res => {
            //       num++
            //       if (res == 'OK')
            //       {
            //         f.status = 'done'
            //       } else
            //       {
            //         f.status = 'failed'
            //         f.message = '上传失败'
            //         // this.$message({ type: 'error', message: res })
            //         Notify({
            //           type: 'danger',
            //           message: res
            //         })
            //       }

            //     })
            //   }
            // })
            // 发送new_acceptid
            // this.$emit('callBackFormRecordData', this.new_acceptid)
          }
        })
        .finally(() => {
          // 发送new_acceptid
          this.$emit('callBackFormRecordData', this.new_acceptid)
        })
    },
    // 格式化makedit类型输入内容（目前数字类型）
    keyup (list) {
      console.log(list, 'list')
      if (list.formdata)
      {
        if (list.maskeditstr == 'Int')
        {
          // 正负整数和0
          list.formdata = list.formdata.replace(/[^\-?\d]/g, '')
          if (list.formdata.lastIndexOf('-') > 0)
          {
            list.formdata = list.formdata.substr(
              0,
              list.formdata.lastIndexOf('-')
            )
          }
          let ary = list.formdata.split('')
          if (ary.length > 0)
          {
            if (ary.length > 1 && ary[0] == 0)
            {
              list.formdata = ary[1]
            } else if (ary.length > 1 && ary[0] == '-')
            {
              if (ary[1] == 0 || ary[1] == '-')
              {
                list.formdata = ''
              }
            }
          }
        } else if (list.maskeditstr == 'PositiveInt')
        {
          // 正整数
          list.formdata = list.formdata.replace(/^(0+)|[^\d]+/g, '')
        } else if (list.maskeditstr == 'NegtiveInt')
        {
          // 负整数
          list.formdata = list.formdata.replace(/^(0+)|[^\-?\d]+/g, '')
          if (list.formdata.lastIndexOf('-') > 0)
          {
            list.formdata = list.formdata.substr(
              0,
              list.formdata.lastIndexOf('-')
            )
          }
          let ary = list.formdata.split('')
          if (ary.length > 0 && ary[0] == '-')
          {
            if (ary[0] == '-' && ary[1] == 0)
            {
              list.formdata = ary[0]
            }
          } else
          {
            list.formdata = ''
          }
        } else if (
          list.maskeditstr.indexOf('Float') != -1 ||
          list.maskeditstr.indexOf('PositiveFloat') != -1 ||
          list.maskeditstr.indexOf('NegtiveFloat') != -1
        )
        {
          list.formdata = list.formdata.replace(/[^\-?\d.]/g, '')
          let ary = list.formdata.split('')
          if (list.formdata.lastIndexOf('-') > 0)
          {
            list.formdata = list.formdata.substr(
              0,
              list.formdata.lastIndexOf('-')
            )
          }
          if (ary[0] == '.')
          {
            list.formdata = ''
          }
          if (ary.length > 1 && ary[0] == 0 && ary[1] != '.')
          {
            list.formdata = ary[1]
          }
          if (list.formdata.split('.').length > 2)
          {
            list.formdata = list.formdata.substr(
              0,
              list.formdata.lastIndexOf('.')
            )
          }
          if (ary[0] == '-')
          {
            if (ary[1] == '.')
            {
              list.formdata = '-'
            } else if (ary[1] == 0 && ary[2] == 0)
            {
              list.formdata = '-0'
            } else if (ary[1] == 0 && ary[2] && ary[2] != 0 && ary[2] != '.')
            {
              list.formdata = '-' + ary[2]
            }
          }
        }
      }
    },
    // 选择省份、城市、镇区的联动选择器确定按钮
    confirmCity (result) {
      let str = ''
      if (result.length > 0)
      {
        result.forEach(el => {
          str += el.name ? el.name : ''
        })
      }
      this.storageSbject.formdata = str
      this.showCitySelector = false
    },
    // 当后台控件类型controltype=maskedit 并且maskeditstr=CitySelector 时，需要在移动端或pc端显示选择省份、城市、镇区的联动选择器
    citySelectorFocus (it) {
      this.showCitySelector = true
      this.storageSbject = it
      // it.formdata = 'nishizenmele?'
    },
    // 保存问卷方法
    saveQsTemplateOptionList () {
      let pd = []
      let paperData = JSON.parse(localStorage.getItem('questionData'))
      if (paperData.length > 0)
      {
        paperData.forEach(item => {
          if (item.qsDetails.length > 0)
          {
            let ary = item.qsDetails.map(it => {
              if (item.qsType == '多选题')
              {
                let answer = it.answer.join(',')
                return { autoid: it.autoid, opres: answer }
              } else
              {
                // 不是多选，就直接返回答案
                return { autoid: it.autoid, opres: it.answer }
              }
            })
            pd = pd.concat(ary)
          }
        })

        let params = {
          rsid: this.new_acceptid,
          paperid: this.paperid,
          data: pd
        }
        saveQsTemplateOptionList(params).then(res => {
          if (res.iserror == 0)
          {
            // 保存成功
          }
        })
      } else
      {
        return
      }
    },
    // 如果 otherAtFileList 还有设置的话，就全部显示到最后的附件位置；
    getOtherFileList () {
      if (this.otherAtFileList)
      {
        let nameAry = this.otherAtFileList.split(',')
        nameAry.forEach(el => {
          let has = false
          this.fileList.forEach(it => {
            if (el == it.name)
            {
              has = true
            }
          })
          if (!has)
          {
            this.fileList.push({
              url: null,
              name: el,
              file: null,
              type: 'no',
              readonly: false
            })
          }
        })
      }
    },
    getFormField () {
      // 请求构造表单的接口
      GetFormFieldDetail({
        moduleno: this.moduleno,
        userid: this.userInfo.userid,
        langid: 0,
        checkfieldpri: this.moduleConfig.checkfieldpri || false,
        colcount: this.moduleConfig.colcount,
        labelwidth: this.moduleConfig.labelwidth,
        controlwidth: this.moduleConfig.controlwidth,
        mviewname: this.moduleConfig.mviewname,
        mkeyname: this.moduleConfig.mkeyname,
        formfieldlist: this.moduleConfig.formfieldlist,
        autoid: 0
      }).then(res => {
        let list = res.fieldlist
        let totalarr = []
        const indexarr = []
        let textboxnum = 1

        let map = {},
          dest = [] // 用来分组的工具
        list.forEach(item => {
          item.uptools = true //默认打开所有分组
          item.oldvalue = '' //记录旧值
          item.haschange = false
          // 主表才赋值岗位
          let fromstaname =
            this.treeNodePre && this.masterisactive == '1'
              ? this.treeNodePre.staname
              : ''
          if (
            (item.fieldname === 'telephone' &&
              this.mode === 'true' &&
              this.moduleno === '240') ||
            (((item.fieldname === 'telephone' && this.mode === 'true') ||
              item.fieldname === 'staname' ||
              item.fieldname === 'stationid') &&
              (this.seStaList.includes(this.moduleno) || fromstaname))
          )
          {
            item.isreadonly = true
          } else if (
            item.fieldname === 'telephone' &&
            this.mode === 'true' &&
            this.moduleno == '322'
          )
          {
            item.isreadonly = true
          }
          if (item.controltype === 'memo')
          {
            item.showline = true
            item.linecaption = item.chnname
            // item.appgroupname = item.chnname
          }
          if (item.formshow && item.showline)
          {
            // 分组线名称

            const idx = list.indexOf(item)
            indexarr.push(idx)
          }
          if (item.formshow && item.controltype === 'memo')
          {
            textboxnum++
          }
          // console.log(this.masterisactive, '1111')
          let new_masterisactive = !this.masterisactive
            ? '1'
            : this.masterisactive.length === 0
              ? '1'
              : this.masterisactive.substr(0, 1)

          if (new_masterisactive.substr(0, 1) === '5' && !item.isreadonly)
          {
            item.isreadonly = item.atreadonly
          }

          //-------------------分组
          if (item.formshow)
          {
            item.formdata = ''
          }
          const param = 'appgroupname'
          if (item.formshow && item[param])
          {
            // if (item.controltype == 'memo')
            // {
            //   dest.push({ name: item.chnname, data: [item] });
            // } else
            // {
            if (!map[item[param]])
            {
              dest.push({ name: item[param], data: [item] })
              map[item[param]] = item
            } else
            {
              for (var j = 0; j < dest.length; j++)
              {
                var dj = dest[j]
                if (dj.name == item[param])
                {
                  dj.data.push(item)
                  break
                }
              }
            }
            // }
          }
        })
        // 代表有分组
        if (dest.length > 0)
        {
          dest.forEach((el, idx) => {
            if (idx == dest.length - 1)
            {
              list.forEach(it => {
                if (!it.appgroupname)
                {
                  el.data.push(it)
                }
              })
            }
            totalarr.push(el.data)
          })
        } else
        {
          // 没有分组信息 就全部放入一个里
          let noGroup = []
          list.forEach(it => {
            noGroup.push(it)
          })
          totalarr.push(noGroup)
        }

        // indexarr.push(list.length)
        // for (let i = 0; i < indexarr.length - 1; i++)
        // {
        //   if (i === 0)
        //   {
        //     const newarr1 = []
        //     const newarr2 = []
        //     for (let j = 0; j < indexarr[0]; j++)
        //     {
        //       list[j].formdata = ''
        //       newarr1.push(list[j])
        //     }
        //     for (let k = indexarr[0]; k < indexarr[1]; k++)
        //     {
        //       list[k].formdata = ''
        //       newarr2.push(list[k])
        //     }
        //     if (newarr1.length > 0) totalarr.push(newarr1)
        //     if (newarr2.length > 0) totalarr.push(newarr2)
        //   } else
        //   {
        //     const newarr3 = []
        //     for (let j = indexarr[i]; j < indexarr[i + 1]; j++)
        //     {
        //       list[j].formdata = ''
        //       newarr3.push(list[j])
        //     }
        //     if (newarr3.length > 0) totalarr.push(newarr3)
        //   }
        // }
        // if (indexarr.length === 1)
        // {
        //   totalarr = [
        //     list.map(item => {
        //       return Object.assign(item, { formdata: '' })
        //     })
        //   ]
        // }
        this.isactive = '1'
        // this.acceptid = '0'
        //this.status = "save";
        this.form.loopData = totalarr
        // console.log(this.form.loopData, 'this.form.loopData')
        this.singleCroList = []
        this.form.loopData.forEach((it, idx) => {
          let obj = {}
          if (idx == 0)
          {
            obj = {
              sqlNum: idx,
              show: true
            }
          } else
          {
            if (this.pageshow == 1 || this.pageshow == '1')
            {
              obj = {
                sqlNum: idx,
                show: false
              }
            } else
            {
              obj = {
                sqlNum: idx,
                show: true
              }
            }
          }
          this.singleCroList.push(obj)
        })
        // 传回去loopData数据外，还需要传控制附件的参数
        this.$parent.getLoopData(
          this.form.loopData,
          this.usedicfilename,
          this.useMasterAtFile,
          this.otherAtFileList
        )
        this.forminfo = res.forminfo

        // 允许主表附加字典类别显示 允许字典附件在某个主表后显示
        if (this.usedicfilename && this.useMasterAtFile)
        {
          this.form.loopData.forEach(ld => {
            ld.forEach(ee => {
              if (this.masterAtFileList.length > 0)
              {
                this.masterAtFileList.forEach(ma => {
                  if (ee.fieldname == ma.fieldname)
                  {
                    const maList = ma.dicname.split(',')
                    // 加载附件名
                    let tempdata = []
                    //普通下拉框只取第一个属性值，并且明明为dicvalue
                    maList.forEach(item => {
                      tempdata.push({
                        url: null,
                        name: item,
                        file: null,
                        type: 'no'
                      })
                    })
                    ld.fileList = tempdata
                  }
                })
              }
            })
          })
        }
        console.log(this.new_saveormodify, 'this.new_saveormodify')
        if (
          this.new_saveormodify === 'modify' ||
          this.new_saveormodify === 'readonly'
        )
        {
          this.getFormRecordData({
            // 获取表格传过来单条信息empid，再调用getformrecorddata接口获取一次信息
            mviewname: this.moduleConfig.mviewname,
            mkeyname: this.moduleConfig.mkeyname,
            formfieldlist: this.moduleConfig.formfieldlist,
            autoid: this.new_acceptid
          })
        } else
        {
          //如果传入主表字段，则更新这个字段
          if (this.mdtkeyfield != '')
          {
            // console.log(this.mdtkeyfield, this.mautoid,'设置');
            this.setValue(this.mdtkeyfield, this.mautoid)
          }

          // console.log(this.treeNodePre, 'this.treeNodePre2222')
          this.setcdefaultvalue(this.treeNodePre, this.moduleno, true)
        }

        this.listLoading = false
      })
    },
    // 获取通用树
    getCommTree (multiseltree) {
      const editstate =
        this.new_acceptid === '' ||
          this.new_acceptid === null ||
          this.new_acceptid === '0' ||
          this.new_acceptid === 0
          ? 1
          : 2
      getCommTreeData({
        moduleno: parseInt(this.moduleno),
        treename: this.Selectformdata.poptreename, // 树名
        username: this.userInfo.username,
        fieldname: this.Selectformdata.fieldname,
        editstate: editstate,
        formstr: JSON.stringify(this.formstr)
      }).then(res => {
        // 如果是多选树，则返回记录添加是否多选，是否选中属性
        if (multiseltree)
        {
          res.data.forEach(element => {
            element.multiple = multiseltree
            element.checked = false
          })
        }
        this.allTreeList = res.data
        // 树结构中最小层级(最上层)
        let mini = Math.min.apply(
          Math,
          res.data.map(item => {
            return item.levelid
          })
        )
        if (this.whichTree == 'station' || this.whichTree == 'employee')
        {
          // 岗位和员工树
          // 初始时的父节点
          this.parentTreeList = res.data.filter(item => {
            return item.levelid == mini
          })
          // 判断父节点有没有下级
          if (this.parentTreeList.length > 0)
          {
            this.parentTreeList.forEach(el => {
              el.hasLower = false
              for (let i = 0; i < this.allTreeList.length; i++)
              {
                const it = this.allTreeList[i]
                if (el.keyid == it.parentid)
                {
                  el.hasLower = true
                  break
                }
              }
            })
          }
          // 初始时的子节点
          this.allTreeList.forEach(el => {
            if (this.parentTreeList.length == 1)
            {
              // 最大父节点只有一个的时候
              let nodecan = false
              if (this.whichTree == 'station')
              {
                nodecan = el.issta
              } else if (this.whichTree == 'employee')
              {
                nodecan = el.isdept == 0 && el.levelid == 16
              }
              if (nodecan && el.parentid == this.parentTreeList[0].keyid)
              {
                this.childsTreeList.push(el)
              }
            } else
            {
              // 最大父节点有多个的时候
              this.childsTreeList = []
            }
          })
        } else
        {
          // 其他树(暂时部门树)
          // 初始时的节点
          this.otherTreeList = res.data.filter(item => {
            return item.levelid == mini
          })
          // 判断初始节点有没有下级
          if (this.otherTreeList.length > 0)
          {
            this.otherTreeList.forEach(el => {
              el.hasLower = false
              for (let i = 0; i < this.allTreeList.length; i++)
              {
                const it = this.allTreeList[i]
                if (el.keyid == it.parentid)
                {
                  el.hasLower = true
                  break
                }
              }
            })
          }
        }
        console.log(this.allTreeList, 'this.allTreeList')
      })
    },
    // 搜索子节点
    onSearchTree (val) {
      // 清空父节点、子节点和已点击过的父节点
      this.parentTreeList = []
      this.childsTreeList = []
      this.clickParentTree = []
      this.otherTreeList = []
      this.allTreeList.forEach(el => {
        let nodecan = false
        if (this.whichTree == 'station')
        {
          nodecan = el.issta
        } else if (this.whichTree == 'employee')
        {
          nodecan = el.isdept == 0 && el.levelid == 16
        }
        // 岗位和人员
        if (this.whichTree == 'station' || this.whichTree == 'employee')
        {
          if (nodecan && el.keyname.indexOf(val) !== -1)
          {
            this.childsTreeList.push(el)
          }
        } // 其他（部门）
        else
        {
          if (el.keyname.indexOf(val) !== -1)
          {
            // 判断节点有没有下级
            let lowerAry = this.allTreeList.filter(it => {
              return it.parentid == el.keyid
            })
            if (lowerAry.length > 0)
            {
              el.hasLower = true
            } else
            {
              el.hasLower = false
            }
            this.otherTreeList.push(el)
          }
        }
      })
    },
    // 回到某个树节点
    backTo (val) {
      if (val === true)
      {
        // 点击的开始,回到最初始状态
        this.parentTreeList = []
        this.childsTreeList = []
        this.clickParentTree = []
        this.otherTreeList = []
        this.searchTreeVal = ''
        this.allTreeList = []
        this.getCommTree(this.multiseltree)
      } else
      {
        // 否则先在clickParentTree去掉该父节点及节点后所有节点
        let ary = [] // 记录该节点及后的所有节点
        for (let i = 0; i < this.clickParentTree.length; i++)
        {
          const ele = this.clickParentTree[i]
          if (val.keyid == ele.keyid)
          {
            // 如果是数组最后一个则不可以点击，数据不变
            if (i == this.clickParentTree.length - 1)
            {
              return false
            } else
            {
              ary = this.clickParentTree.filter((item, index) => {
                return index < i
              })
            }
          }
        }
        this.clickParentTree = ary
        // 去掉之后再区分（岗位和员工）和其他树
        if (this.whichTree == 'station' || this.whichTree == 'employee')
        {
          // 岗位和员工树
          // 再获取该父节点下的子节点
          this.checkParent(val)
        } else
        {
          // 其他树
          this.hasLower(val)
        }
      }
    },
    // 其他树点击下级
    hasLower (val) {
      // 储存点击过的有下级的父节点
      if (val.hasLower)
      {
        this.clickParentTree.push(val)
      }
      // 获取此节点下所有子节点
      let array = this.allTreeList.filter(item => {
        return item.parentid == val.keyid
      })
      if (array.length > 0)
      {
        this.otherTreeList = []
        array.forEach(item => {
          // 判断节点有没有下级
          let lowerAry = this.allTreeList.filter(it => {
            return it.parentid == item.keyid
          })
          if (lowerAry.length > 0)
          {
            item.hasLower = true
          } else
          {
            item.hasLower = false
          }
          // 父节点
          this.otherTreeList.push(item)
        })
      }
    },
    // 点击树的父节点(针对岗位和员工树)
    checkParent (val) {
      // 储存点击过的有下级的父节点
      if (val.hasLower)
      {
        this.clickParentTree.push(val)
      }
      // 获取此父节点下所有节点
      let array = this.allTreeList.filter(item => {
        return item.parentid == val.keyid
      })
      // 遍历所有节点并分出父节点和子节点
      if (array.length > 0)
      {
        this.parentTreeList = []
        this.childsTreeList = []
        array.forEach(item => {
          let nodecan = false
          if (this.whichTree == 'station')
          {
            nodecan = item.issta
          } else if (this.whichTree == 'employee')
          {
            nodecan = item.isdept == 0 && item.levelid == 16
          }
          if (nodecan)
          {
            // 子节点
            this.childsTreeList.push(item)
          } else
          {
            // 判断父节点有没有下级
            let lowerAry = this.allTreeList.filter(it => {
              return it.parentid == item.keyid
            })
            if (lowerAry.length > 0)
            {
              item.hasLower = true
            } else
            {
              item.hasLower = false
            }
            // 父节点
            this.parentTreeList.push(item)
          }
        })
      }
    },
    // 选择父节点复选框
    tickParent (item) {
      // 判断父节点有没有下级
      let lowerAry = this.allTreeList.filter(it => {
        return it.parentid == item.keyid
      })
      if (lowerAry.length > 0)
      {
        if (item.checked == true)
        {
          lowerAry.forEach(ele => {
            this.allTreeList.map(it => {
              if (it.keyid == ele.keyid)
              {
                it.checked = true
              }
            })
            this.tickParent(ele)
          })
        } else
        {
          lowerAry.forEach(ele => {
            this.allTreeList.map(it => {
              if (it.keyid == ele.keyid)
              {
                it.checked = false
              }
            })
            this.tickParent(ele)
          })
        }
      }
    },
    // 多选树清除复选框选中
    cleanChecked () {
      this.allTreeList.forEach(item => {
        item.checked = false
      })
    },
    // 多选树确认复选框选中
    comfirmChecked () {
      let array = this.allTreeList.filter(ele => {
        return ele.checked == true
      })
      let trueList = []
      if (array.length > 0)
      {
        if (this.whichTree == 'station')
        {
          for (let i = 0; i < array.length; i++)
          {
            const it = array[i]
            if (it.issta == true)
            {
              trueList.push(it)
            }
          }
        } else if (this.whichTree == 'employee')
        {
          for (let l = 0; l < array.length; l++)
          {
            const item = array[l]
            if (item.isdept == 0 && item.levelid == 16)
            {
              trueList.push(item)
            }
          }
        } else
        {
          // 其他树
          trueList = array
        }
      }
      this.checkChild(trueList)
      console.log(trueList, 'trueListtrueList')
    },
    // 点击树的子节点(暂时单选树)(针对岗位和员工树)
    checkChild (it) {
      let checked = []
      this.hasEXfieldlist = []
      if (this.Selectformdata.multiseltree)
      {
        checked = it
        //多选树
        const namelist = checked.map(it =>
          it.keyname.indexOf(' ') != -1 ? it.keyname.split(' ')[0] : it.keyname
        )
        const names = namelist.join(',')
        this.setValue(this.Selectformdata.fieldname, String(names))
        // 下拉字段带出过程
        if (this.Selectformdata.isexitvalue)
        {
          this.valuechage(names, this.Selectformdata) //判断数据带出
        }
      } else
      {
        checked = [it]
        //单选树
        if (this.whichTree == 'station' || this.whichTree == 'employee')
        {
          this.setValue(
            this.Selectformdata.fieldname,
            String(
              checked[0].keyname.indexOf(' ') != -1
                ? checked[0].keyname.split(' ')[0]
                : checked[0].keyname
            )
          )
        } else
        {
          this.setValue(
            this.Selectformdata.fieldname,
            String(
              checked[0].keyname.indexOf(' ') != -1
                ? checked[0].keyname.split(' ')[1]
                : checked[0].keyname
            )
          )
        }
        this.setValue(
          this.Selectformdata.popupdatefield,
          String(checked[0][this.Selectformdata.popbackkeyid])
        )
        // 下拉字段带出过程
        if (this.Selectformdata.isexitvalue)
        {
          this.valuechage(
            String(
              checked[0].keyname.indexOf(' ') != -1
                ? checked[0].keyname.split(' ')[0]
                : checked[0].keyname
            ),
            this.Selectformdata
          ) //判断数据带出
        }
        //转化字段带出过程
        this.form.loopData.forEach(item => {
          item.forEach(it => {
            if (
              it.isexitvalue &&
              it.fieldname === this.Selectformdata.popupdatefield
            )
            {
              this.valuechage(checked[0][this.Selectformdata.popbackkeyid], it) //判断数据带出
            }
          })
        })
      }
      // 最终关闭弹窗
      this.showTreePop = false
    },
    // 获取下拉选项（combobox，lookupcombobox）
    comboboxNoispoptreefocus (data, controltype, e) {
      this.updateformstr()
      this.Selectformdata = e
      GetFilterDropDownList({
        moduleno: this.moduleno,
        username: this.userInfo.username,
        listsql: data,
        formstr: JSON.stringify(this.formstr)
      }).then(res => {
        if (controltype === 'filse')
        {
          // 加载附件名
          let tempdata = []
          //普通下拉框只取第一个属性值，并且明明为dicvalue
          res.data.forEach(item => {
            tempdata.push({
              url: null,
              name: item[Object.keys(item)[0]],
              file: null,
              type: 'no',
              readonly: false
            })
          })
          if (!this.isSon)
          {
            this.fileList = tempdata
          }
        } else if (controltype === 'combobox')
        {
          let tempdata = []
          //普通下拉框只取第一个属性值，并且明明为dicvalue
          res.data.forEach(item => {
            // tempdata.push({ dicvalue: item[Object.keys(item)[0]] })
            tempdata.push(item[Object.keys(item)[0]])
          })
          this.choices = tempdata
          this.showPicker = true
          // this.showPickerData(tempdata, e) //打开下拉框
        } else if (controltype === 'lookupcombobox')
        {
          let tempdata2 = { head: [{ name: [], width: [] }], data: [] }
          if (res.data.length > 0)
          {
            Object.keys(res.data[0]).forEach(item => {
              tempdata2.head[0].name.push(item)
              tempdata2.head[0].width.push(item.toString().length)
            })
          }
          //表格下拉框需要新增表头数据
          for (let i = 0; i < res.data.length; i++)
          {
            var tp = { keyId: '', text: '' }
            for (let j = 0; j < tempdata2.head[0].name.length; j++)
            {
              // tp.push(res.data[i][tempdata2.head[0].name[j]])
              // if (res.data[i][tempdata2.head[0].name[j]] != null) {
              //   let vl = res.data[i][tempdata2.head[0].name[j]].toString()
              //     .length
              //   tempdata2.head[0].width[j] =
              //     tempdata2.head[0].width[j] >= vl
              //       ? tempdata2.head[0].width[j]
              //       : vl
              // }
              if (res.data[i][tempdata2.head[0].name[j]] != null)
              {
                if (j === 0)
                {
                  tp.keyId = res.data[i][tempdata2.head[0].name[j]].toString()
                  tp.text = tp.keyId
                } else
                {
                  tp.text += '/' + res.data[i][tempdata2.head[0].name[j]]
                }
              }
            }
            tempdata2.data.push(tp)
          }
          this.choices = tempdata2.data
          this.showPicker = true
        }
      })
    },
    // 下拉框输入自动添加选项
    addoption (list, e) {
      let v = e.target.value
      if (list.comdropstyle === 'lsEditList' && v !== '')
      {
        //允许手动输入
        if (
          list.formshow &&
          list.controltype === 'combobox' &&
          !list.ispoptree
        )
        {
          //普通输入框
          if (this.choices === '') this.choices = []
          const op = { dicvalue: v }
          if (this.choices.indexOf(op) === -1) this.choices.push(op)
        } else if (
          list.formshow &&
          list.controltype === 'lookupcombobox' &&
          !list.ispoptree
        )
        {
          // console.log(this.choices,'lookupcombobox');
          if (this.choices === '') this.choices = {}
          if (this.choices.head.length === 0)
          {
            //无表头
            this.choices.head = [{ name: ['dicvalue'], width: [8] }]
          }
          let has = false
          this.choices.data.forEach(choice => {
            if (choice[0] === v)
            {
              has = true
              return
            }
          })
          if (!has)
          {
            let tp = []
            this.choices.head[0].name.forEach((choice, i) => {
              if (i === 0)
              {
                tp.push(v)
              } else
              {
                tp.push('')
              }
            })
            this.choices.data.push(tp)
          }
        }
        list.formdata = v
        this.valuechage(v, list)
      }
    },
    // 弹出下拉树
    showTree (e) {
      this.multiseltree = e.multiseltree
      this.Selectformdata = e
      this.showTreePop = true
      if (
        e.poptreename.indexOf('stationtree') > -1 ||
        e.poptreename == 'stationidtree'
      )
      {
        this.whichTree = 'station'
      } else if (e.poptreename == 'emptree')
      {
        this.whichTree = 'employee'
      } else
      {
        this.whichTree = 'other'
      }
      console.log(this.Selectformdata, 'this.Selectformdata ')
      this.getCommTree(e.multiseltree)
      // this.$refs.addtree.show = true //开发中
    },
    // 弹出自定义查询窗体
    showCuQuery (e, b4multi) {
      this.singleSel = b4multi ? false : true
      this.updateformstr()
      const data = {
        moduleno: this.moduleno,
        username: this.userInfo.username,
        fieldvalue: e.formdata,
        popqueryproc:
          'psys_showcustomquery_' + this.moduleno + '_' + e.fieldname,
        formstr: JSON.stringify(this.formstr)
      }
      GetCustomQueryInfo(data).then(res => {
        this.customQueryQueryparaminfo = res.queryparaminfo
        this.customQueryForminfo = res.forminfo[0]
        // this.customQueryForminfo.showtree = false
        // this.customQueryForminfo.multisel = false
        //console.log(res, 'customQueryForminfo')
        this.Selectformdata = e
        this.$refs.customQuery.show = true
      })
    },
    // 选择员工
    showSelectJobNum (e, b4multi) {
      this.singleSel = b4multi ? false : true
      this.Selectformdata = e
      this.$refs.selectJobNum.show = true
    },
    // 自定义查询返回值
    customQueryReturn (retfieldArr, updatefield) {
      if (this.singleSel)
      {
        const g = [] // 用来存取选中员工工号传过来的临时存储数组
        for (let n = 0; n < retfieldArr.length; n++)
        {
          // 循环_arr数组中元素
          // 判断_empty数组中是否有_arr数组中的第n个元素,小于0就是没有
          // 如果没有就把这个元素添加到_empty数组中
          if (g.indexOf(retfieldArr[n]) < 0)
          {
            g.push(retfieldArr[n])
          }
        }
        const i = g.join(',')
        this.setValue(updatefield, i)
        this.setValue(this.Selectformdata.fieldname, i)
        this.valuechage(i, this.Selectformdata)
      } else
      {
        this.multiReceive('others', retfieldArr, updatefield)
        //this.$emit('multiReceive', 'others', retfieldArr, updatefield)
      }
    },
    // 新版下拉树弹出框返回过程
    conTreeShowreturn (action, checked) {
      if (action === 'confirm')
      {
        this.$emit('setCanSave', true)
        this.hasEXfieldlist = []
        if (this.Selectformdata.multiseltree)
        {
          //多选树
          const namelist = checked.map(it =>
            it.keyname.indexOf(' ') != -1
              ? it.keyname.split(' ')[0]
              : it.keyname
          )
          const names = namelist.join(',')
          this.setValue(this.Selectformdata.fieldname, String(names))
          // 下拉字段带出过程
          if (this.Selectformdata.isexitvalue)
          {
            this.valuechage(names, this.Selectformdata) //判断数据带出
          }
        } else
        {
          //单选树
          this.setValue(
            this.Selectformdata.fieldname,
            String(
              checked[0].keyname.indexOf(' ') != -1
                ? checked[0].keyname.split(' ')[0]
                : checked[0].keyname
            )
          )
          this.setValue(
            this.Selectformdata.popupdatefield,
            String(checked[0][this.Selectformdata.popbackkeyid])
          )
          // 下拉字段带出过程
          if (this.Selectformdata.isexitvalue)
          {
            this.valuechage(
              String(
                checked[0].keyname.indexOf(' ') != -1
                  ? checked[0].keyname.split(' ')[0]
                  : checked[0].keyname
              ),
              this.Selectformdata
            ) //判断数据带出
          }
          //转化字段带出过程
          this.form.loopData.forEach(item => {
            item.forEach(it => {
              if (
                it.isexitvalue &&
                it.fieldname === this.Selectformdata.popupdatefield
              )
              {
                this.valuechage(
                  checked[0][this.Selectformdata.popbackkeyid],
                  it
                ) //判断数据带出
              }
            })
          })
        }
      }
    },
    // 获取员工工号
    getEmpNum (empidArr, empnameArr, empcodeArr) {
      if (this.singleSel)
      {
        const g = [] // 用来存取选中员工工号传过来的临时存储数组
        for (let n = 0; n < empcodeArr.length; n++)
        {
          // 循环_arr数组中元素
          // 判断_empty数组中是否有_arr数组中的第n个元素,小于0就是没有
          // 如果没有就把这个元素添加到_empty数组中
          if (g.indexOf(empcodeArr[n]) < 0)
          {
            g.push(empcodeArr[n])
          }
        }
        const i = g.join(',')
        this.setValue(this.Selectformdata.fieldname, i)
        this.valuechage(i, this.Selectformdata)
      } else
      {
        this.multiReceive('empcode', empcodeArr, '', empidArr)
        //this.$emit('multiReceive', 'empcode', empcodeArr, '', empidArr)
      }
    },
    //工号字段输入姓名自动转化
    changeEmpname (val, list) {
      getEmpInfo({ empcode: val })
        .then(res => {
          if (res.data.length === 0)
          {
            //没有查到记录直接使用输入值进行带出
            val = ''
            this.setValue(list.fieldname, val)
            this.valuechage(val, list)
          } else if (res.data.length === 1)
          {
            //只有1笔记录，直接赋值
            val = res.data[0].empcode
            this.setValue(list.fieldname, val)
            this.valuechage(val, list)
          } else
          {
            //返回多笔记录，显示弹窗供用户选择
            this.empcodeData = res.data
            this.Selectformdata = list
            this.singleSel = true
            this.active = 'empTable'
          }
        })
        .catch(e => {
          this.valuechage(val, list)
        })
    },
    setValueSel (filename, val = '') {
      filename = filename ? filename : this.Selectformdata.filename
      this.setValue(filename, val)
    },
    b4valuechage (val, list) {
      this.valuechage(list.formdata, list)
    },
    // 表单change事件（判断是否触发数据带出）
    valuechage (val, list) {
      this.$emit('setCanSave', true)
      this.hasEXfieldlist = []
      list.haschange = true
      list.newvalue = val
      //先触发退出提醒
      if (
        list.isexitshowinfo &&
        list.formdata !== '' &&
        list.formdata !== null
      )
      {
        //启用退出提醒
        let fun = this.ExitInfo
        this.bulidExitValue(list.fieldname, val, fun)
      }
      if (list.isexitvalue)
      {
        //启用数据带出
        let fun = this.ExitValue
        this.bulidExitValue(list.fieldname, val, fun)
      }
    },
    // 数据带出修改只读状态
    setReadOnly (n, isreadonly, key) {
      this.form.loopData.forEach(it => {
        it.forEach(i => {
          if (i.fieldname === n)
          {
            i[key] = isreadonly
          }
        })
      })
    },
    // 设置字段值（不触发数据带出）
    setValue (n, v, tar = 'new') {
      this.form.loopData.forEach(it => {
        it.forEach(i => {
          if (i.fieldname === n)
          {
            let vv = v
            /*数据转化处理
              （bit类型要把 1 转成 true 其他为false）
              日期控件需要转成date格式
              readonly 的情况要转成字符串
            */
            if (i.fielddatatype === 'bit')
            {
              const truearr = [1, '1', 'true', 'True', 'TRUE', true]
              if (this.new_saveormodify !== 'readonly')
              {
                vv = truearr.indexOf(v) != -1 ? true : false
              } else
              {
                vv = truearr.indexOf(v) != -1 ? '是' : '否'
              }
            } else if (
              i.controltype === 'datetime' &&
              vv !== null &&
              this.new_saveormodify !== 'readonly'
            )
            {
              // vv = vv.replace(/-/g, '/')
              // vv = new Date(vv)
              // if (!(vv instanceof Date && !isNaN(vv.getTime()))) {
              //   // console.log(i.fieldname, vv, v)
              //   return false
              // }
            } else if (i.controltype === 'colorcombobox' && vv !== null)
            {
              // console.log(vv, '#' + int2hex(vv), 'colorcombobox')
              vv = '#' + int2hex(vv)
            } else if (i.controltype === 'memo' && vv !== null)
            {
              vv = vv.replace(/\\n/g, '\n ')
            }
            i.formdata = vv
            if (tar === 'old')
            {
              i.oldvalue = vv
              i.haschange = false
              i.newvalue = ''
            } else if (tar === 'new')
            {
              i.haschange = true
              i.newvalue = vv
            }
          }
        })
      })
      this.$forceUpdate()
    },
    // 构造数据带出结构体，发起数据打出请求
    bulidExitValue (n, v, fun) {
      // console.log(n, v, fun, 111111111)

      this.updateformstr()
      const totalformstr = JSON.stringify(this.formstr)
      const editstate =
        this.new_acceptid === '' ||
          this.new_acceptid === null ||
          this.new_acceptid === '0' ||
          this.new_acceptid === 0
          ? 1
          : 2
      const data = {
        editstate: editstate,
        moduleno: this.moduleno,
        fieldname: n,
        fieldvalue: v,
        username: this.userInfo.username,
        formstr: totalformstr
      }
      if (typeof fun === 'function')
      {
        fun(data)
      }
    },
    // 数据带出
    ExitValue (data) {
      if (this.hasEXfieldlist.indexOf(data.fieldname) == -1)
      {
        this.hasEXfieldlist.push(data.fieldname)
        GetFormFieldExitValue(data).then(res => {
          const data = res.data
          data.forEach(item => {
            if ('isreadonly' in item)
            {
              // 如果带出过程携带isreadonly，则修改对应字段的isreadonly值
              if (item.isreadonly != null)
                this.setReadOnly(item.fieldname, item.isreadonly, 'isreadonly')
            }

            if ('mustinput' in item)
            {
              // 如果带出过程携带mustinput，则修改对应字段的mustinput值
              if (item.mustinput != null)
                this.setReadOnly(item.fieldname, item.mustinput, 'mustinput')
            }
            if (item.fieldvalue != '<OrgFieldValue>')
              this.setValue(item.fieldname, item.fieldvalue)
            // // 将返回的数据赋值给对应表格
            // this.form.loopData.forEach(it => {
            //   it.forEach(i => {
            //     if (i.fieldname === item.fieldname) {
            //       i.formdata = item.fieldvalue
            //     }
            //   })
            // })
          })
        })
      }
    },
    // 离开提醒方法
    async ExitInfo (data) {
      let result = ''
      await GetFormFieldExitInfo(data).then(res => {
        if (res.data[0].atext)
        {
          result = res.data[0].atext
          if (res.data[0].atext !== '')
          {
            //触发系统提示框
            this.$emit('writeSysTips', res.data[0].atext)
          }
        }
      })
      return result
    },
    // 判断必填字段是否已经填写
    checkmustinput (b4multi) {
      let msg = false
      for (let o = 0; o < this.form.loopData.length; o++)
      {
        let element = this.form.loopData[o]
        for (let k = 0; k < element.length; k++)
        {
          let i = element[k]
          if (
            i.mustinput &&
            (i.formdata === null || i.formdata === '') &&
            !(
              b4multi &&
              this.moduleConfig.canselmulti &&
              i.fieldname === this.moduleConfig.multifieldname &&
              this.new_status === 'save'
            )
          )
          {
            // this.$message({ type: 'error', message: i.chnname + ' 必填！' })
            Notify({
              type: 'danger',
              message: i.chnname + ' 必填！'
            })
            this.$emit('changPage', o, 'main')
            msg = true
            if (
              i.controltype === 'edit' ||
              (i.controltype === 'combobox' && i.showpopquery) ||
              (i.controltype === 'combobox' &&
                i.ispoptree &&
                i.poptreename != 'emptree') ||
              (i.controltype === 'combobox' &&
                i.ispoptree &&
                i.poptreename === 'emptree') ||
              i.controltype === 'maskedit' ||
              i.controltype === 'memo'
            )
            {
              setTimeout(() => {
                this.$refs[i.fieldname][0].focus()
              }, 1000)
            }
            // break
            return msg
          }
        }
      }
      return msg
    },
    // 更新formstr
    updateformstr () {
      this.logdetail = ''
      let logdetailarr = []

      this.form.loopData.forEach(item => {
        item.forEach(it => {
          this.formstr[it.fieldname] =
            it.formdata === null || it.formdata === undefined
              ? 'null'
              : it.formdata === '' &&
                (it.controltype === 'datetime' ||
                  this.datetime.indexOf(it.fielddatatype) != -1 ||
                  this.floatarry.indexOf(it.fielddatatype) != -1 ||
                  this.intarry.indexOf(it.fielddatatype) != -1)
                ? 'null'
                : it.formdata === ''
                  ? it.formdata
                  : it.controltype === 'datetime'
                    ? it.formdata
                    : it.controltype === 'longdatetime'
                      ? parseTime(it.formdata)
                      : it.formdata && it.controltype === 'colorcombobox'
                        ? hex2int(it.formdata)
                        : it.formdata.toString()

          if (it.haschange && this.status === 'modify')
          {
            logdetailarr.push(
              '{' +
              it.fieldname +
              ',' +
              it.chnname +
              ',' +
              it.oldvalue +
              ',' +
              it.newvalue +
              '}'
            )
          }
        })
      })
      this.logdetail = logdetailarr.join(',')
      if (this.sqnum)
      {
        this.formstr.sqnum = this.sqnum
      }
      if (this.moduleno == 240)
      {
        this.formstr.crman = this.pcuserinfo
      }
      // console.log(this.logdetail,this.status,'this.logdetail');
      this.$emit('updateformstr', this.formstr, this.logdetail)
      return this.formstr
    },
    // 时间补:方法
    handleTimeInput: function (e) {
      e.target.value = e.target.value.replace(/[^\d:]/g, '')
      if (e.target.value && e.target.value.length === 2)
      {
        if (this.keycode != 8)
        {
          const t = parseInt(e.target.value)
          if (t > 48 || t < 0)
          {
            //时 不能超过48
            e.target.value = e.target.value.substr(0, e.target.value.length - 1)
          } else
          {
            e.target.value += ':'
          }
        } else
        {
          e.target.value = e.target.value.substr(0, e.target.value.length - 1)
        }
      }
      if (e.target.value && e.target.value.length >= 5 && this.keycode != 8)
      {
        const t = parseInt(e.target.value.split(':')[1])
        if (t > 59 || t < 0)
        {
          //分 不能超过59
          e.target.value = e.target.value.substr(0, e.target.value.length - 1)
        } else
        {
          e.target.value = e.target.value.substr(0, 5)
        }
      }
    },
    // 日期补-方法
    handleDateInput: function (e) {
      if (
        e.target.value &&
        (e.target.value.length === 4 || e.target.value.length === 7)
      )
      {
        if (this.keycode != 8)
        {
          e.target.value += '-'
        } else
        {
          e.target.value = e.target.value.substr(0, e.target.value.length - 1)
        }
      }
      if (e.target.value && e.target.value.length >= 10 && this.keycode != 8)
      {
        e.target.value = e.target.value.substr(0, 10)
      }
    },
    // 日期时间补所有方法
    handleDateTimeInput: function (e) {
      if (
        e.target.value &&
        (e.target.value.length === 4 || e.target.value.length === 7)
      )
      {
        if (this.keycode != 8)
        {
          e.target.value += '-'
        } else
        {
          e.target.value = e.target.value.substr(0, e.target.value.length - 1)
        }
      }
      if (e.target.value && e.target.value.length === 10 && this.keycode != 8)
      {
        if (this.keycode != 8)
        {
          e.target.value += ' '
        } else
        {
          e.target.value = e.target.value.substr(0, e.target.value.length - 1)
        }
      }
      if (
        e.target.value &&
        (e.target.value.length === 13 || e.target.value.length === 16) &&
        this.keycode != 8
      )
      {
        if (this.keycode != 8)
        {
          e.target.value += ':'
        } else
        {
          e.target.value = e.target.value.substr(0, e.target.value.length - 1)
        }
      }
      if (e.target.value && e.target.value.length >= 19 && this.keycode != 8)
      {
        e.target.value = e.target.value.substr(0, 19)
      }
    },
    // 整数
    handleIntInput: function (e) {
      e.target.value = e.target.value.replace(/^-[0-9]*[1-9][0-9]*$/g, '')
    },
    // 非负整数
    handleNonIntInput: function (e) {
      e.target.value = e.target.value.replace(/[^\d]/g, '')
    },
    // 小数点后两位number
    handleMoneyInput: function (e) {
      e.target.value = e.target.value.match(/^\d*(\.?\d{0,2})/g)[0] || null
    },
    // 小数
    handleFloatInput: function (e) {
      let v = e.target.value
      v = v.replace(/[^\d.]/g, '') //清除“数字”和“.”以外的字符
      v = v.replace(/\.{2,}/g, '.') //只保留第一个. 清除多余的
      // v = v.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
      // v = v.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3');//只能输入两个小数
      e.target.value = v || null
    },
    // 键盘监听
    keydown: function (e) {
      this.keycode = e.keyCode
    },
    // 弹窗组件的关闭事件
    activeClose () {
      this.active = ''
    },
    // 设置表单新建默认值
    setcdefaultvalue (treeNode, moduleno, newDefaultValue) {
      // console.log(treeNode,moduleno,newDefaultValue,1111);

      //优先赋值tree选中值获取
      let data = []
      if (treeNode !== null)
      {
        if (moduleno === '101' || moduleno === '104')
        {
          data.push({
            fieldname: 'parentdeptname',
            cdefaultvalue: treeNode.keyname
          })
          data.push({
            fieldname: 'parentdeptid',
            cdefaultvalue: treeNode.deptid
          })
          data.push({
            fieldname: 'parentid',
            cdefaultvalue: treeNode.keyid
          })
        } else if (moduleno === '102' || moduleno === '609')
        {
          data.push({
            fieldname: 'deptautoid',
            cdefaultvalue: treeNode.autoid
          })
          data.push({
            fieldname: 'deptname',
            cdefaultvalue: treeNode.keyname
          })
          data.push({
            fieldname: 'deptid',
            cdefaultvalue: treeNode.deptid
          })
        } else if (moduleno === '702')
        {
          data.push({
            fieldname: 'mautoid',
            cdefaultvalue: treeNode.keyid
          })
        } else if (moduleno === '703')
        {
          data.push({
            fieldname: 'itemname',
            cdefaultvalue: treeNode.keyname
          })
          data.push({
            fieldname: 'ruletypename',
            cdefaultvalue: treeNode.parentName
          })
          data.push({
            fieldname: 'mautoid',
            cdefaultvalue: treeNode.autoid
          })
        } else if (moduleno === '9901')
        {
          data.push({
            fieldname: 'dictypename',
            cdefaultvalue: treeNode.keyname
          })
        } else if (moduleno === '113')
        {
          // 虚拟组织
          data.push(
            {
              fieldname: 'parentdeptid', // 父部门编号
              cdefaultvalue: treeNode.deptid
            },
            {
              fieldname: 'parentdeptname', // 父部门名称
              cdefaultvalue: treeNode.deptname
            },
            {
              fieldname: 'levelid', // 层级
              cdefaultvalue: treeNode.scheme
            },
            {
              fieldname: 'planname', // 预算方案
              cdefaultvalue: treeNode.schemeName
            },
            {
              fieldname: 'bgplanid', // 预算方案id
              cdefaultvalue: treeNode.autoid
            }
          )
        } else if (moduleno === '114')
        {
          // 虚拟岗位
          data.push(
            {
              fieldname: 'planname', // 预算方案
              cdefaultvalue: treeNode.schemeName
            },
            {
              fieldname: 'deptname', // 所属部门
              cdefaultvalue: treeNode.keyname
            },
            {
              fieldname: 'bgplanid', // 预算方案id
              cdefaultvalue: treeNode.scheme
            },
            {
              fieldname: 'deptautoid', // 所属部门id
              cdefaultvalue: treeNode.autoid
            }
          )
        } else if (moduleno === '240')
        {
          // 虚拟岗位
          data.push({
            fieldname: 'restype', // 投递方式
            cdefaultvalue: this.restype || '微信招聘'
          })
          if (this.tel)
          {
            data.push({
              fieldname: 'telephone', // 手机
              cdefaultvalue: this.tel
            })
          }
        } else if (moduleno === '306')
        {
          // 员工简历
          data.push({
            fieldname: 'empid', // empid
            cdefaultvalue: this.localempid
          })
        } else if (moduleno === '322')
        {
          // 虚拟岗位
          data.push({
            fieldname: 'restype', // 投递方式
            cdefaultvalue: this.restype || '微信招聘'
          })
          if (this.tel)
          {
            data.push({
              fieldname: 'telephone', // 手机
              cdefaultvalue: this.tel
            })
          }
        } else if (this.seStaList.includes(moduleno))
        {
          // 虚拟岗位
          data.push({
            fieldname: 'restype', // 投递方式
            cdefaultvalue: this.restype || '微信招聘'
          })
          if (this.tel)
          {
            data.push({
              fieldname: 'telephone', // 手机
              cdefaultvalue: this.tel
            })
          }
        } else
        {
          // 其他模块均允许保存手机号
          if (this.tel)
          {
            data.push({
              fieldname: 'telephone', // 手机
              cdefaultvalue: this.tel
            })
            data.push({
              fieldname: 'mobilephone', // 手机
              cdefaultvalue: this.tel
            })
          }
        }
      }
      // console.log(this.treeNodePre,'this.treeNodePre');

      if (this.treeNodePre.staname || this.treeNodePre.stationid)
      {
        data.push({
          fieldname: 'stationid', // 岗位id
          cdefaultvalue: this.treeNodePre.stationid
        })
        data.push({
          fieldname: 'staname', // 岗位名称
          cdefaultvalue: this.treeNodePre.staname
        })
        data.push({
          fieldname: 'deptname', // 部门
          cdefaultvalue: this.treeNodePre.deptname
        })
        data.push({
          fieldname: 'deptid', // deptid
          cdefaultvalue: this.treeNodePre.deptid
        })
        data.push({
          fieldname: 'deptautoid', // deptautoid
          cdefaultvalue: this.treeNodePre.deptautoid
        })
      }
      data.forEach(item => {
        this.setValue(item.fieldname, item.cdefaultvalue, 'old')
        this.form.loopData.forEach(it => {
          it.forEach(i => {
            if (i.fieldname === item.fieldname && i.isexitvalue)
            {
              //启用数据带出
              this.bulidExitValue(
                item.fieldname,
                item.cdefaultvalue,
                this.ExitValue
              )
            }
          })
        })
      })
      // this.updateformstr()
      this.updateformstr()
      if (newDefaultValue)
      {
        //获取新建默认值
        GetFormNewDefaultValue({
          moduleno: moduleno,
          username: this.userInfo.username,
          formstr: JSON.stringify(this.formstr),
          masterformstr:
            this.masterformstr && this.masterisactive.substr(0, 1) === '5'
              ? this.masterformstr
              : ''
        }).then(res => {
          // 如果是组织架构或者岗位管理，额外添加treeNode的部门节点

          let data = res.data
          data.forEach(item => {
            this.setValue(item.fieldname, item.cdefaultvalue)
            this.form.loopData.forEach(it => {
              it.forEach(i => {
                if (i.isexitvalue && i.fieldname === item.fieldname)
                {
                  //启用数据带出
                  this.bulidExitValue(
                    item.fieldname,
                    item.cdefaultvalue,
                    this.ExitValue
                  )
                }
              })
            })
          })
        })
      }
    },
    //批量添加前先检查表单必填字段
    b4multi (e) {
      this.updateformstr()
      if (this.checkmustinput(true))
      {
      } else
      {
        //判断字段是不是empcode
        if (e.fieldname === 'empcode')
        {
          this.showSelectJobNum(e, true)
        } else
        {
          this.showCuQuery(e, false)
        }
      }
    },
    //批量添加，接收数据处理
    async multiReceive (tar, retfieldArr, updatefield, empidArr) {
      this.strinfo = '批量新增'
      this.$refs.gressDialog.outShow = false
      this.gressDialog = true
      this.empcode = retfieldArr
      this.singleSel = false
      this.total = retfieldArr.length
      for (let n = 0; n < retfieldArr.length; n++)
      {
        if (tar === 'empcode')
        {
          this.setValue('empcode', retfieldArr[n])
          this.setValue('empid', empidArr[n])
        } else
        {
          this.setValue(updatefield, retfieldArr[n])
          this.setValue(this.Selectformdata.fieldname, retfieldArr[n])
        }
        await this.beforeAction()
        this.gressIdx = n + 1
      }
    },
    // 保存前动作
    // onlycheck=true  只执行保存前过程，检查是否存在报错，没有报错则显示签名框。如果flase表示是执行保存
    beforeAction (json, onlycheck = false) {
      let promptdata1 = []
      return new Promise(async (resolve, reject) => {
        this.updateformstr()
        if (json)
        {
          for (var jn in json)
          {
            this.formstr[jn] = String(json[jn]) //这个要传字符串，无论是数字类型还是Boolean类型，都要转换成字符串类型，这是接口要求
          }
        }

        try
        {
          const res1 = await GetBeforeActionList({
            // 先请求保存接口1，获得acprocname
            actype: 0,
            moduleno: this.moduleno,
            username: this.userInfo.username
          })
          const arr = res1.data // acprocname数组

          for (const item of arr)
          {
            const editstate =
              this.new_acceptid === '' ||
                this.new_acceptid === null ||
                this.new_acceptid === '0' ||
                this.new_acceptid === 0
                ? 1
                : 2
            const result = await ProcessBeforeAction({
              acproname: item.acprocname,
              editstate: editstate,
              moduleno: this.moduleno,
              username: this.userInfo.username,
              autoid: this.new_acceptid,
              formstr: JSON.stringify(this.formstr) // 表格填写信息
            })

            if (result.data.length > 0)
            {
              // 当有报错信息后，跳转到报错信息字段页
              for (let l = 0; l < this.form.loopData.length; l++)
              {
                const ele = this.form.loopData[l]
                for (let e = 0; e < ele.length; e++)
                {
                  const it = ele[e]
                  if (it.fieldname == result.data[0].fieldname)
                  {
                    this.$emit('changPage', l, this.isSon ? 'son' : 'main')
                  }
                }
              }

              promptdata1.push(result.data[0])
            } else
            {
              promptdata1.push({
                isinfo: true,
                info: result.errormsg,
                showbox: true,
                cansave: false
              })
            }
          }
        } catch (e)
        {
          promptdata1.push({
            isinfo: true,
            info: e.errormsg,
            showbox: true,
            cansave: false
          })
        }

        this.postAction(promptdata1, onlycheck)
          .then(res => {
            resolve(true)
          })
          .catch(err => {
            resolve(false)
          })
        // .then(resolve(true))
        // .catch(resolve(false))
      })
    },
    //保存前返回值处理+保存动作
    postAction (n, onlycheck) {
      this.showCanSave = (onlycheck && this.usepresign) || !this.usepresign
      // console.log(n,111);
      // 侦查prompdata，发生变化就启动弹窗，询问用户是否要保存，若选择保存则继续循环询问；若选择不保存，就跳出循环。
      // 对新增/修改数据进行保存
      return new Promise(async (resolve, reject) => {
        const arr = n
        const saveornot = []
        // 处理formstr数字转换成字符串
        for (const key in this.formstr)
        {
          if (!isNaN(this.formstr[key]))
          {
            this.formstr[key] = String(this.formstr[key])
          }
        }
        // 处理...
        // const res = await aaa(arr)
        // if (res) {

        // } else {

        // }
        for (let i = 0; i < arr.length; i++)
        {
          if (arr[i].isinfo && !arr[i].cansave)
          {
            if (this.singleSel)
            {
              // this.$message.error(arr[i].info)
              Notify({
                type: 'danger',
                message: arr[i].info
              })
              saveornot.push(1)
            } else
            {
              //批量保存保存提示
              // this.writeSysTips(arr[i].info)
              this.$emit('writeSysTips', arr[i].info)
              const a = this.empcode.length
              this.progress = a === 0 ? 100 : this.progress + 100 / a
            }
            this.$emit('setCanSave', true)
            reject()
            return
          } else if (arr[i].isinfo && arr[i].cansave && this.showCanSave)
          {
            if (this.singleSel)
            {
              const a = await this.ask(arr[i].info)
              if (!a)
              {
                saveornot.push(0)
                // 当点击取消时取消保存或提交
                this.$emit('setCanSave', true)
                return false
              }
            } else
            {
              const a = this.empcode.length
              this.progress = a === 0 ? 100 : this.progress + 100 / a
              return true
            }
            resolve()
          }
        }
        if (saveornot.length > 0)
        {
          if (saveornot.some(i => i == 1))
          {
            if (this.singleSel)
            {
              // this.$message({ type: 'error', message: '保存失败' })
              Notify({
                type: 'danger',
                message: '保存失败'
              })
            } else
            {
              //批量保存保存提示
              // this.writeSysTips('保存失败')
              this.$emit('writeSysTips', '保存失败')

              const a = this.empcode.length
              this.progress = a === 0 ? 100 : this.progress + 100 / a
              //return true
            }
            this.$emit('setCanSave', true)
          }
          reject()
        } else
        {
          // 这里接入主表的签名确认
          if (onlycheck)
          {
            // this.$emit('showQM')
            resolve()
          } else
          {
            // 签名完毕
            const editstate =
              this.new_acceptid === '' ||
                this.new_acceptid === null ||
                this.new_acceptid === '0' ||
                this.new_acceptid === 0
                ? 1
                : 2
            //this.formstr.empid = this.new_acceptid
            this.formstr[this.mkeyname] = this.new_acceptid //更新主键
            // 处理formstr数字转换成字符
            for (const key in this.formstr)
            {
              if (!isNaN(this.formstr[key]))
              {
                this.formstr[key] = String(this.formstr[key])
              }
            }
            // console.log(this.new_acceptid, this.acceptid, 0)
            // 1.猎头公司（module=317)，crman传入：system_lt
            // 2.校园招聘（module=319)，crman传入：system_xy
            // 3.校园招聘（module=240)，crman传入：system_restype
            // 4.其他模块的crman传入：system_wx
            // 5.派遣公司（module=322），crman传入：system_pq
            let userName = 'system_wx'
            if (this.moduleno == 240)
            {
              this.formstr.crman = this.pcuserinfo
              userName = this.pcuserinfo
            } else if (this.moduleno == 317)
            {
              // this.formstr.crman = 'system_lt'
              userName = 'system_lt'
            } else if (this.moduleno == 319)
            {
              // this.formstr.crman = 'system_xy'
              userName = 'system_xy'
            } else if (this.moduleno == 304)
            {
              // this.formstr.crman = 'system_wx'
              userName = 'system_wx'
              this.formstr.tj_empid = this.tj_empid
            } else if (this.moduleno == 322)
            {
              // this.formstr.crman = 'system_wx'
              userName = 'system_pq'
            } else
            {
              // this.formstr.crman = 'system_wx'
              userName = 'system_wx'
            }
            if (this.zpacid)
            {
              // 如下图，招聘活动的二维码地址格式，针对moduleno=319并且地址参数传了zpacid的值（这个是招聘活动id），在最后保存简历时api/wx/postModuleRecord，要给formstr 传入 zpacid这个参数；
              this.formstr.zpacid = this.zpacid
            }
            if (editstate === 2)
            {
              this.formstr.autoid = this.new_acceptid + ''
            }
            this.formstr.ispost = '1'
            PostModuleRecord({
              moduleno: this.moduleno,
              editstate: editstate,
              // pcuserinfo: this.pcuserinfo, // 用户名称,
              pcuserinfo: userName,
              formstr: JSON.stringify(this.formstr),
              logdetail: this.logdetail
            })
              .then(res => {
                const data = res.data[0]
                if (res.iserror === '0' && !data.info)
                {
                  if (this.singleSel)
                  {
                    if (editstate === 1)
                    {
                      // console.log(editstate)

                      this.new_acceptid = data.insid
                      // console.log(data.insid,'acceptid5');
                      this.setValue(this.mkeyname, this.new_acceptid)
                      // this.$message({ type: 'success', message: '保存成功' })
                    } else
                    {
                      // this.$message({ type: 'success', message: '修改成功' })
                    }
                  }
                  //触发保存后动作
                  ProcessAfterAction({
                    actype: 0,
                    editstate: editstate,
                    moduleno: this.moduleno,
                    username: this.userInfo.username, // 用户名称,
                    autoid: this.new_acceptid,
                    formstr: JSON.stringify(this.formstr)
                  }).finally(() => {
                    if (this.singleSel)
                    {
                      const d = {
                        mviewname: this.moduleConfig.mviewname,
                        mkeyname: this.moduleConfig.mkeyname,
                        formfieldlist: this.moduleConfig.formfieldlist,
                        autoid: this.new_acceptid
                      }

                      let fileAry = []
                      // 允许主表附加字典类别显示 允许字典附件在某个主表后显示
                      // 把每个分隔线后的附件遍历上传
                      if (this.usedicfilename && this.useMasterAtFile)
                      {
                        this.form.loopData.forEach(ld => {
                          if (ld.fileList)
                          {
                            ld.fileList.forEach(it => {
                              fileAry.push(it)
                            })
                          }
                        })
                      }
                      this.fileList.forEach(f => {
                        fileAry.push(f)
                      })

                      let filenum = 0
                      fileAry.forEach(f => {
                        if (!f.type)
                        {
                          filenum++
                        }
                      })
                      if (filenum > 0)
                      {
                        // 上传附件
                        let num = 0
                        fileAry.forEach((f, index) => {
                          if (!f.type)
                          {
                            f.status = 'uploading'
                            f.message = '上传中...'

                            this.upLoadBase64(
                              f.file,
                              f.name ? f.name + '.' + f.ext : null
                            ).then(res => {
                              num++
                              if (res == 'OK')
                              {
                                f.status = 'done'
                              } else
                              {
                                f.status = 'failed'
                                f.message = '上传失败'
                                // this.$message({ type: 'error', message: res })
                                Notify({
                                  type: 'danger',
                                  message: res
                                })
                              }
                              if (num == filenum)
                              {
                                this.$emit(
                                  'getFormRecordData',
                                  d,
                                  this.new_acceptid
                                )
                                // 保存后重新获取一次当前记录的所有字段
                                this.getFormRecordData({
                                  // 获取表格传过来单条信息empid，再调用getformrecorddata接口获取一次信息
                                  mviewname: this.moduleConfig.mviewname,
                                  mkeyname: this.moduleConfig.mkeyname,
                                  formfieldlist: this.moduleConfig
                                    .formfieldlist,
                                  autoid: this.new_acceptid
                                })
                              }
                            })
                          }
                        })
                      } else
                      {
                        this.$emit('getFormRecordData', d, this.new_acceptid)
                        // 保存后重新获取一次当前记录的所有字段
                        this.getFormRecordData({
                          // 获取表格传过来单条信息empid，再调用getformrecorddata接口获取一次信息
                          mviewname: this.moduleConfig.mviewname,
                          mkeyname: this.moduleConfig.mkeyname,
                          formfieldlist: this.moduleConfig.formfieldlist,
                          autoid: this.new_acceptid
                        })
                      }
                      resolve()
                    }

                    // if (this.autoid == 0 && this.sq == 1)
                    if (
                      (this.submmited_qs == true ||
                        this.submmited_qs == 'true') &&
                      this.sq == 1
                    )
                    {
                      // 保存问卷
                      this.saveQsTemplateOptionList()
                      this.sq++
                    }
                  })
                } else if (res.iserror === '0' && data.info)
                {
                  if (this.singleSel)
                  {
                    // this.$message({ type: 'error', message: data.info })
                    Notify({
                      type: 'danger',
                      message: data.info
                    })
                  } else
                  {
                    //批量保存保存提示
                    // this.writeSysTips(data.info)
                    this.$emit('writeSysTips', data.info)
                  }
                  this.$emit('setCanSave', true)
                  reject()
                }
              })
              .catch(err => {
                if (this.singleSel)
                {
                  // this.$message.error(JSON.stringify(err))
                  Notify({
                    type: 'danger',
                    message: JSON.stringify(err)
                  })
                } else
                {
                  //批量保存保存提示
                  // this.writeSysTips(err)
                  this.$emit('writeSysTips', err)
                }
                this.$emit('setCanSave', true)
                reject()
              })
              .finally(() => {
                if (!this.singleSel)
                {
                  const a = this.empcode.length
                  this.progress = a === 0 ? 100 : this.progress + 100 / a
                }
              })
          }
        }
      })
    },
    //循环保存方法
    // 进度条
    gressBeforeClose (action, done) {
      if (action === 'confirm')
      {
        this.gressDialog = false
        this.progress = 0
        // this.close()
        // this.$message({ type: 'success', message: '批量增加成功' })
        Notify({ type: 'success', message: '批量增加成功' })
        this.new_status = 'save'
        this.new_saveormodify = 'save'
        // this.get(this.moduleno)
        this.$emit('get', this.moduleno)
        done()
      } else
      {
        this.gressDialog = false
        done()
      }
    },
    ask (msg) {
      // element弹窗
      return new Promise((resolve, reject) => {
        // this.$confirm(msg, '提示', {
        //   confirmButtonText: '确定',
        //   cancelButtonText: '取消',
        //   type: 'warning'
        // })
        Dialog.confirm({
          title: '系统提示',
          message: msg
        })
          .then(() => {
            resolve(true)
          })
          .catch(() => {
            resolve(false)
          })
      })
    },
    showdatepick (e) {
      this.Selectformdata = e
      this.currentDate = e.formdata ? new Date(e.formdata) : new Date()
      this.showDtPicker = true
      if (this.$refs[this.Selectformdata.fieldname])
      {
        this.$refs[this.Selectformdata.fieldname][0].blur()
      }
    },
    onConfirm (value, index) {
      if (this.Selectformdata.chnname === '附件名称')
      {
        // 是附件需要重新命名
        let f = this.fileList[this.fileList.length - 1]
        f.name = value + f.file.name.substring(f.file.name.lastIndexOf('.'))
        this.Selectformdata.chnname = ''
      } else if (this.Selectformdata.controltype === 'combobox')
      {
        this.setValue(this.Selectformdata.fieldname, value)
        if (this.Selectformdata.isexitvalue)
        {
          this.valuechage(value, this.Selectformdata)
        }
      } else if (this.Selectformdata.controltype === 'lookupcombobox')
      {
        this.setValue(this.Selectformdata.fieldname, this.choices[index].keyId)
        // 下拉字段带出过程
        if (this.Selectformdata.isexitvalue)
        {
          this.valuechage(this.choices[index].keyId, this.Selectformdata)
        }
      }

      this.showPicker = false
    },
    onCancel () {
      if (!(this.Selectformdata.chnname === '附件名称')) this.showPicker = false
    },
    onDtConfirm (value) {
      const v = parseTime(value, '{y}-{m}-{d}')
      this.setValue(this.Selectformdata.fieldname, v)
      if (this.Selectformdata.isexitvalue)
      {
        this.valuechage(v, this.Selectformdata)
      }
      this.showDtPicker = false
    },
    // 重命名file
    reFileName (file, name) {
      const tempFile = file
      const type = tempFile.type
      const size = tempFile.size
      // const newName = new Date().getTime() + tempFile.name
      const newName =
        name || Math.round(Math.random() * 1000000) + tempFile.name
      let uploadFile = new File([tempFile], newName, { type, size })
      return uploadFile
      //调用文件上传接口上传文件
    },
    // 上传附件接口
    async uploadfile (file, rename = true) {
      return await upLoadFile({
        moduleno: this.moduleno,
        upflag: '2',
        autoid: this.new_acceptid,
        uploadpath: this.attachfilepath,
        username: this.userInfo.username,
        file: rename ? this.reFileName(file) : file
      })
    },
    // 上传base64附件
    async upLoadBase64 (file, name) {
      let str = ''
      // console.log(file, 'filesize,filesizefilesize');
      // quality: 0.6--67.99% 、0.4--76.18% 、 0.2--83.90%
      let quality = 0.6
      if (file.size >= 1024 * 1024 * 0.5 && 1024 * 1024 * 1 > file.size)
      {
        quality = 0.8
      }
      if (file.size >= 1024 * 1024 * 1 && 1024 * 1024 * 2 > file.size)
      {
        quality = 0.6
      }
      if (file.size >= 1024 * 1024 * 2 && 1024 * 1024 * 5 > file.size)
      {
        quality = 0.4
      }
      if (file.size >= 1024 * 1024 * 5)
      {
        quality = 0.2
      }
      let f = name || file.name
      const ext = f.substring(f.lastIndexOf('.') + 1)
      if ('png|jpg|jpeg|emp'.includes(ext))
      {
        // 如果是图片，则先压缩，防止提交失败
        file = await this.compressorImage(file, 'file', quality)
      }
      await this.getBase64(file).then(res => {
        str = res.split('base64,')[1]
      })
      return this.upLoadBase64File(str, name || file.name)
    },
    // 压缩图片
    compressorImage (image, backType, quality) {
      return new Promise((resolve, reject) => {
        new Compressor(image, {
          quality: quality || 0.8,
          success (result) {
            let lastIndexOf = image.name.lastIndexOf('.')
            let name = image.name.substr(0, lastIndexOf) + '.png'
            // console.log(image, 'image.type', name);
            let file = new File([result], name, { type: 'image/png' })
            // console.log(file, 'filefilefile');
            if (!backType || backType == 'blob')
            {
              resolve(result)
            } else if (backType == 'file')
            {
              resolve(file)
            } else
            {
              resolve(file)
            }
          },
          error (err) {
            console.log('图片压缩失败---->>>>>', err)
            reject(err)
          }
        })
      })
    },
    // 上传附件，base64格式
    upLoadBase64File (str, name) {
      const filename = name.substring(0, name.lastIndexOf('.'))
      const fileext = name.substring(name.lastIndexOf('.') + 1)
      console.log(this.new_acceptid)
      return upLoadBase64FileFixName({
        moduleno: this.moduleno,
        upflag: '2',
        autoid: this.new_acceptid,
        uploadpath: this.attachfilepath,
        username: this.userInfo.username,
        filename: filename,
        fileext: fileext,
        filebase64str: str,
        packagetype: this.usedicfilename ? filename : ''
      })
    },
    // 文件转base64
    getBase64 (file) {
      const tempFile = file
      const type = tempFile.type
      const size = tempFile.size
      // const newName = new Date().getTime() + tempFile.name
      const newName = Math.round(Math.random() * 1000000) + tempFile.name
      let uploadFile = new File([tempFile], newName, { type, size })
      // if (size >= 300000)      {
      //   // 压缩？
      //   // alert(tempFile.size);
      // } else      {

      // }
      return new Promise(function (resolve, reject) {
        let reader = new FileReader()
        let imgResult = ''
        reader.readAsDataURL(uploadFile)
        reader.onload = function () {
          imgResult = reader.result
        }
        reader.onerror = function (error) {
          reject(error)
        }
        reader.onloadend = function () {
          resolve(imgResult)
        }
      })
    },
    getFormRecordData (data) {
      //根据id获取当前单据原数据(不触发数据带出)
      // getformrecorddata接口
      GetFormRecordData(data).then(res => {
        console.log('getFormRecordData')
        const data = res.data[0]
        // this.new_acceptid = res.data[0][this.mkeyname]
        if (this.new_saveormodify !== 'readonly')
        {
          this.new_status = 'modify'
        } else
        {
        }
        this.$nextTick(() => {
          for (var item in data)
          {
            if (item == 'restype' && this.restype)
            {
              this.setValue('restype', this.restype)
              console.log(this.restype, '111111111')
            } else
            {
              this.setValue(item, data[item], 'old')
            }
          }
          if (this.treeNodePre)
          {
            // if (this.treeNodePre.staname)
            //   this.setValue('staname', this.treeNodePre.staname)
            // if (this.treeNodePre.stationid)
            // this.setValue('stationid', this.treeNodePre.stationid)
            this.setcdefaultvalue(this.treeNodePre, this.moduleno, false)
          }
          //加载附件
          this.getappendix()
        })
      })
    },
    //获取附件列表
    getappendix () {
      // 获取附件接口信息并处理数据
      getmoduleattfilelist({
        moduleno: this.moduleno,
        mautoid: this.new_acceptid,
        username: this.userInfo.username
      }).then(res => {
        for (let index = 0; index < res.module_atlist.length; index++)
        {
          const item = res.module_atlist[index]
          if (item.sfilename === 'sign')
          {
            this.$emit('setSign', item.url)
            break
          }
        }
        let fileList0 = this.filehandleData(res)
        let emppicArr = fileList0.filter(
          item =>
            item.sfilename === 'emp_' + this.new_acceptid ||
            item.sfilename === 'cap1_' + this.new_acceptid ||
            item.sfilename === 'cap2_' + this.new_acceptid
        )
        let fileList = fileList0.filter(
          item =>
            !(
              item.sfilename === 'emp_' + this.new_acceptid ||
              item.sfilename === 'cap1_' + this.new_acceptid ||
              item.sfilename === 'cap2_' + this.new_acceptid ||
              item.sfilename === 'sign'
            )
        )

        if (this.usedicfilename)
        {
          if (this.useMasterAtFile)
          {
            fileList.forEach(k => {
              // let has = false
              k.file = null
              k.name = k.sfilename
              this.form.loopData.forEach(ld => {
                if (ld.fileList)
                {
                  ld.fileList.forEach(it => {
                    if (it.name == k.name)
                    {
                      // has = true
                      it.autoid = k.autoid
                      it.crdate = k.crdate
                      it.crman = k.crman
                      it.file = k.file
                      it.fileext = k.fileext
                      it.isImage = k.isImage
                      it.mautoid = k.mautoid
                      it.moduleno = k.moduleno
                      it.name = k.name
                      it.sfilename = k.sfilename
                      it.type = k.type
                      it.url = k.url + '?v=' + Date.parse(new Date())
                    }
                  })
                }
              })
              this.fileList.forEach(e => {
                if (e.name == k.name)
                {
                  // has = true
                  e.autoid = k.autoid
                  e.crdate = k.crdate
                  e.crman = k.crman
                  e.file = k.file
                  e.fileext = k.fileext
                  e.isImage = k.isImage
                  e.mautoid = k.mautoid
                  e.moduleno = k.moduleno
                  e.name = k.name
                  e.sfilename = k.sfilename
                  e.type = k.type
                  e.url = k.url + '?v=' + Date.parse(new Date())
                }
              })
              // if (!has)              {
              //   this.fileList.push(k)
              // }
            })
          } else
          {
            fileList.forEach(k => {
              let has = false
              k.file = null
              k.name = k.sfilename
              this.fileList.forEach(e => {
                if (e.name == k.name)
                {
                  has = true
                  e.autoid = k.autoid
                  e.crdate = k.crdate
                  e.crman = k.crman
                  e.file = k.file
                  e.fileext = k.fileext
                  e.isImage = k.isImage
                  e.mautoid = k.mautoid
                  e.moduleno = k.moduleno
                  e.name = k.name
                  e.sfilename = k.sfilename
                  e.type = k.type
                  e.url = k.url + '?v=' + Date.parse(new Date())
                }
              })
              if (!has)
              {
                this.fileList.push(k)
              }
            })
          }
        } else
        {
          if (this.isSon == true && this.detailAtList.length > 0)
          {
            // 如果子表的附件有命名
            this.detailAtList.forEach(it => {
              if (it.dt_moduleno == this.moduleno)
              {
                fileList.forEach(k => {
                  let has = false
                  k.file = null
                  k.name = k.sfilename
                  this.fileList.forEach(e => {
                    if (e.name == k.name)
                    {
                      has = true
                      e.autoid = k.autoid
                      e.crdate = k.crdate
                      e.crman = k.crman
                      e.file = k.file
                      e.fileext = k.fileext
                      e.isImage = k.isImage
                      e.mautoid = k.mautoid
                      e.moduleno = k.moduleno
                      e.name = k.name
                      e.sfilename = k.sfilename
                      e.type = k.type
                      e.url = k.url + '?v=' + Date.parse(new Date())
                    }
                  })
                  if (!has)
                  {
                    this.fileList.push(k)
                  }
                })
              }
            })
          } else
          {
            this.fileList = fileList
          }
        }
        for (let index = 0; index < emppicArr.length; index++)
        {
          const item = emppicArr[index]
          const params = {
            dflag: '2',
            moduleno: this.moduleno,
            autoid: this.acceptid,
            filename: item.sfilename,
            fileext: item.fileext,
            downloadpath: this.attachfilepath
          }
          getDownLoadFileName(params).then(e => {
            var url = e + '?v=' + Date.parse(new Date())
            let img = new Image()
            img.src = url
            img.onload = () => {
              //判断图片是否加载成功
              if (
                item.sfilename === 'emp_' + this.new_acceptid ||
                item.sfilename === 'cap1_' + this.new_acceptid ||
                item.sfilename === 'cap2_' + this.new_acceptid
              )
              {
                const type =
                  item.sfilename === 'emp_' + this.new_acceptid
                    ? 1
                    : item.sfilename === 'cap1_' + this.new_acceptid
                      ? 2
                      : item.sfilename === 'cap2_' + this.new_acceptid
                        ? 3
                        : 0
                this.$emit('setTx', type, url, item.sfilename, item.fileext)
              }
            }
          })
        }
        for (let index = 0; index < this.fileList.length; index++)
        {
          const item = this.fileList[index]
          // console.log(item, 1111)
          if (item.type === 'pic')
          {
            const params = {
              dflag: '2',
              moduleno: this.moduleno,
              autoid: this.acceptid,
              filename: item.sfilename,
              fileext: item.fileext,
              downloadpath: this.attachfilepath
            }
            getDownLoadFileName(params).then(e => {
              var url = e + '?v=' + Date.parse(new Date())
              let img = new Image()
              img.src = url
              img.onload = () => {
                //判断图片是否加载成功
                this.fileList[index].url = url
              }
            })
          }
        }

        if (this.usedicfilename && this.useMasterAtFile)
        {
          this.form.loopData.forEach((ld, idx) => {
            if (ld.fileList)
            {
              ld.fileList.forEach((it, dx) => {
                if (it.type === 'pic')
                {
                  const params = {
                    dflag: '2',
                    moduleno: this.moduleno,
                    autoid: this.acceptid,
                    filename: it.sfilename,
                    fileext: it.fileext,
                    downloadpath: this.attachfilepath
                  }
                  getDownLoadFileName(params).then(e => {
                    var url = e + '?v=' + Date.parse(new Date())
                    let img = new Image()
                    img.src = url
                    img.onload = () => {
                      //判断图片是否加载成功
                      it.url = url
                      this.$forceUpdate()
                    }
                  })
                }
              })
            }
          })
        }
        this.$forceUpdate()
      })
    }, // 附件数据处理
    filehandleData (list) {
      let groups = [] // 分组[后缀]
      let res = [] // 第一次分类的集合
      if (list.module_atlist)
      {
        list.module_atlist.forEach(item => {
          let type = ''
          let groupName = !item.aftype ? '' : item.aftype
          const ext = item.fileext.slice(1) // 后缀
          let url = ''
          if ('doc|docx'.includes(ext))
          {
            name = 'WORD文件'
            type = 'doc'
            url = require('@/assets/img/word.png')
          } else if ('xlsx|xls'.includes(ext))
          {
            name = 'EXCEL文件'
            type = 'xls'
            url = require('@/assets/img/excel2.png')
          } else if ('ppt|pptx'.includes(ext))
          {
            name = 'PPT文件'
            type = 'ppt'
            url = require('@/assets/img/ppt2.png')
          } else if ('pdf'.includes(ext))
          {
            name = 'PDF文件'
            type = 'pdf'
            url = require('@/assets/img/picture.png')
          } else if ('png|jpg|jpeg|emp'.includes(ext))
          {
            name = '图片文件'
            type = 'pic'
            url = require('@/assets/img/picture.png')
          } else if ('zip|rar'.includes(ext))
          {
            name = '压缩文件'
            type = 'zip'
            url = require('@/assets/img/zip.png')
          } else
          {
            name = '其他文件'
            type = 'default'
            url = require('@/assets/img/xmind.png')
          }
          item.type = type
          item.url = url
          item.isImage = true
          res.push(item)
        })
      }
      if (list.other_atlist)
      {
        list.other_atlist.forEach(item => {
          let type = ''
          const ext = item.fileext.slice(1) // 后缀
          let groupName = !item.aftype ? '' : item.aftype
          let url = ''
          if ('doc|docx'.includes(ext))
          {
            name = 'WORD文件'
            type = 'doc'
            url = require('@/assets/img/word.png')
          } else if ('xlsx|xls'.includes(ext))
          {
            name = 'EXCEL文件'
            type = 'xls'
            url = require('@/assets/img/excel2.png')
          } else if ('ppt|pptx'.includes(ext))
          {
            name = 'PPT文件'
            type = 'ppt'
            url = require('@/assets/img/ppt2.png')
          } else if ('pdf'.includes(ext))
          {
            name = 'PDF文件'
            type = 'pdf'
            url = require('@/assets/img/picture.png')
          } else if ('png|jpg|jpeg|emp'.includes(ext))
          {
            name = '图片文件'
            type = 'pic'
            url = require('@/assets/img/picture.png')
          } else if ('zip|rar'.includes(ext))
          {
            name = '压缩文件'
            type = 'zip'
            url = require('@/assets/img/zip.png')
          } else
          {
            name = '其他文件'
            type = 'default'
            url = require('@/assets/img/xmind.png')
          }
          item.type = type
          item.url = url
          item.isImage = true
          res.push(item)
        })
      }
      return res
    },
    // 删除前判断
    beforeDel (file) {
      // console.log(file, 'filefilefilefile');
      return new Promise((resolve, reject) => {
        if (file.autoid && this.notDeleteAtfile)
        {
          Notify({
            type: 'danger',
            message: '该文件不允许删除！'
          })
          reject(false)
        } else
        {
          resolve()
        }
      })
    },
    deletefile (file) {
      if (file.type)
      {
        deleteFile({
          dflag: 2,
          moduleno: this.moduleno,
          autoid: this.acceptid,
          filename: file.sfilename,
          fileext: file.fileext,
          downloadpath: this.attachfilepath
        }).then(res => { })
      }
    },
    dd (m) {
      //日期控件的最大日期/最小日期
      const d = new Date()
      const year = d.getFullYear()
      const month = d.getMonth()
      const day = d.getDate()
      if (m === 'min')
      {
        return new Date(year - 100, month, day)
      } else
      {
        return new Date(year + 30, month, day)
      }
    },
    onOversize (file) {
      // console.log(file);
      // this.$message.error('文件大小不能超过 10M')
      Notify({
        type: 'danger',
        message: '文件大小不能超过 10M'
      })
    },
    // 打开上传头像
    openUpload (pic) {
      if (pic.readonly) return
      if (this.notChangeAtfile && pic.autoid)
      {
        return
      }
      this.selPic = pic
      this.$refs.uploader.chooseFile()
    },
    // 选择图片后，判断是否需要修改命名
    beforeRead (file) {
      // 获取后缀名
      const ext = file.name.substring(file.name.lastIndexOf('.') + 1)
      let url = '',
        name = '',
        type = ''
      if ('doc|docx'.includes(ext))
      {
        name = 'WORD文件'
        type = 'doc'
        url = require('@/assets/img/word.png')
      } else if ('xlsx|xls'.includes(ext))
      {
        name = 'EXCEL文件'
        type = 'xls'
        url = require('@/assets/img/excel2.png')
      } else if ('ppt|pptx'.includes(ext))
      {
        name = 'PPT文件'
        type = 'ppt'
        url = require('@/assets/img/ppt2.png')
      } else if ('pdf'.includes(ext))
      {
        name = 'PDF文件'
        type = 'pdf'
        url = require('@/assets/img/picture.png')
      } else if ('png|jpg|jpeg|emp'.includes(ext))
      {
        name = '图片文件'
        type = 'pic'
        url = require('@/assets/img/picture.png')
      } else if ('zip|rar'.includes(ext))
      {
        name = '压缩文件'
        type = 'zip'
        url = require('@/assets/img/zip.png')
      } else
      {
        name = '其他文件'
        type = 'default'
        url = require('@/assets/img/xmind.png')
      }
      this.selPic.type = null
      this.selPic.url = url
      this.selPic.isImage = true
      this.selPic.ext = ext
      this.selPic.file = this.reFileName(file, this.selPic.name + '.' + ext)
      if (name == '图片文件')
      {
        this.getBase64(file).then(res => {
          this.selPic.url = res
          this.$forceUpdate()
        })
      }
      return false
    },

    // 删除头像
    del (e) {
      if (e.sfilename)
      {
        this.deletefile(e)
        e.sfilename = null
        e.fileext = null
      }
      e.file = null
      e.url = null
      this.$forceUpdate()
    }
  }
}
</script>
<style lang="less" scoped>
// 身份证弹窗
.idcard_popup {
  .title_div {
    font-size: 5vw;
    color: #fff;
    padding: 2vw 0;
    text-align: center;
    background: #1a8afa;
    .title {
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
      .van-icon {
        position: absolute;
        left: 10px;
      }
    }
  }
  .upload_idcard {
    display: flex;
    padding: 20px;
    .card_po {
      margin-right: 16px;
      background: rgba(224, 240, 255) no-repeat;
      flex: 1;
      .van-uploader {
        margin: 16px 16px 0 16px;
        width: calc(100% - 32px);
        /deep/.van-uploader__wrapper {
          .van-uploader__upload,
          .van-uploader__preview {
            width: 100% !important;
            margin: 0;
            .van-image {
              width: 100% !important;
            }
          }
          .van-uploader__upload {
            background: url("~@/assets/img/idcard_zhengmian.png") no-repeat;
            background-size: 100% 100%;
          }
        }
      }
    }
    .bank_card {
      .van-uploader {
        margin: 16px 16px 0 16px;
        width: calc(100% - 32px);
        /deep/.van-uploader__wrapper {
          .van-uploader__upload,
          .van-uploader__preview {
            width: 100% !important;
            margin: 0;
            .van-image {
              width: 100% !important;
            }
          }
          .van-uploader__upload {
            background: url("~@/assets/img/bank_card.png") no-repeat;
            background-size: 100% 100%;
          }
        }
      }
    }
    .card_back {
      background: rgba(224, 240, 255);
      flex: 1;
      .van-uploader {
        margin: 16px 16px 0 16px;
        width: calc(100% - 32px);
        /deep/.van-uploader__wrapper {
          .van-uploader__upload,
          .van-uploader__preview {
            width: 100% !important;
            margin: 0;
            .van-image {
              width: 100% !important;
            }
          }
          .van-uploader__upload {
            background: url("~@/assets/img/idcard_fanmian.png") no-repeat;
            background-size: 100% 100%;
          }
        }
      }
    }
  }
  .idcard_form {
    margin-top: 20px;
    height: calc(100% - 590px);
    overflow-y: auto;
    .van-form {
      .van-cell {
        /deep/.van-cell__title {
          color: #030303;
        }
      }
    }
  }
  .bankCard_form {
    height: calc(100% - 790px) !important;
  }
  .idcard_foot {
    width: 100%;
    position: absolute;
    left: 0;
    bottom: 20px;
    text-align: center;
    .van-button {
      width: 90%;
      border-radius: 12px;
    }
  }
}
.addFrom {
  .van-form {
    .right_content {
      padding: 0 0;
      .right_titlepar:before {
        content: "";
        position: absolute;
        width: 2.66667vw;
        height: 11.46667vw;
        left: -1.33333vw;
        top: 0;
        bottom: 0;
        background-color: #287eff;
        border-radius: 1.33333vw;
      }
      .right_titlepar {
        position: relative;
        // border-bottom: 1px solid #ccc;
        border-bottom: 1px solid #bababc;
        // #bababc
        padding: 0 4vw;
        .right_title {
          display: flex;
          justify-content: space-between;
          align-items: center;
          font-size: 5vw;
          min-height: 11.46667vw;
          // line-height: 11.46667vw;
          .msgTitle {
            width: 100%;
            text-align: center;
          }
          .lump {
            height: 3vw;
            width: 1vw;
            // background: $active-color;
            display: inline-block;
            margin-right: 1vw;
          }
          .titlebtn {
            background: none;
            border: none;
            font-size: 20px;
          }
          .titlebtn:hover {
            background: none;
            border: none;
            // color: $active-color;
          }
        }
      }
      .sheet {
        margin-top: 10px;
        width: 100%;
        display: flex;
        flex-direction: column;
        .elwrapper:after {
          content: "";
          position: absolute;
          bottom: 0;
          left: 2.66vw;
          right: 2.66vw;
          height: 1px;
          border-top: 0.13333vw solid #70b6ff;
          // border-top: 0.13333vw solid #eee;
          // #969799
        }
        .elwrapper {
          display: flex;
          align-items: center;
          flex: none;
          width: 100%;
          // padding: 0 4vw;
          min-height: 10vw;
          // line-height: 10vw;
          position: relative;
          padding: 2vw 0;
          // padding-bottom: 2vw;
          // margin-bottom: 2vw;
          .field-app_caption_sep_row {
            display: block;
            /deep/.van-cell__title,
            .van-field__label {
              width: 100%;
            }
          }
          .van-cell--required {
            /deep/.van-field__label {
              color: red;
            }
          }
          .el-form-item {
            margin-bottom: 0px;
            width: 100%;
            display: flex;
            .readonly-label {
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 1; /* 限制在一个块元素显示的文本的行数 */
              -webkit-box-orient: vertical; /* 垂直排列 */
              word-break: break-all; /* 内容自动换行 */
            }
            /deep/ .el-form-item__label {
              font-size: 3.46vw;
              flex-shrink: 0;
              width: 35vw;
              min-height: 10vw;
              line-height: 1em;
              display: flex;
              align-items: center;
              justify-content: flex-end;
              padding-left: 10px;
              // text-align: left;
              // background: #000;
            }
            /deep/ label.el-checkbox {
              // 复选框标签长度
              width: auto;
            }
            /deep/ .el-form-item__content {
              // background: #000;
              width: 100%;
              padding-right: 10px;
              min-height: 10vw;
              .el-input {
                width: 100%;
                .el-input__inner {
                  width: 100%;
                  min-height: 10vw;
                  // line-height: 10vw;
                  border-radius: 0px;
                  padding: 0 0.16rem;
                  font-size: 3.46vw;
                  border: none;
                  // border-color: #aaa;
                }
                .el-input__prefix {
                  right: 5px;
                  left: initial;
                  font-size: 3.46vw;
                  color: #606266;
                }
                .el-input__suffix {
                  right: 30px;
                }
              }
              .el-textarea {
                display: flex;
                align-items: center;
                height: 100%;
                .el-textarea__inner {
                  font-size: 3.46vw;
                  // border-color: #aaa;
                  border-radius: 0px;
                  // min-height: 100%!important;
                }

                // width: 5.2rem;
                // height: 2rem;
              }
              .el-select {
                width: 100%;
                .el-input .el-input__suffix {
                  right: 5px;
                }
              }
            }
          }
          /deep/.switch_item {
            .el-form-item__content {
              display: flex;
              align-items: center;
              .switch_box {
                background: unset;
                align-items: center;
                height: 40px;
                .el-switch__core {
                  height: 40px;
                  border-radius: 20px;
                }
                .el-switch__core:after {
                  width: 32px;
                  height: 32px;
                }
              }
              .el-switch.is-checked .el-switch__core::after {
                margin-left: -32px;
              }
            }
          }
          .el-form-item.memo {
            display: block;
            padding-left: 10px;
            /deep/ .el-form-item__label {
              font-size: 3.46vw;
              flex-shrink: 0;
              width: 35vw;
              min-height: 10vw;
              line-height: 1em;
              display: flex;
              align-items: center;
              justify-content: flex-start;
              padding-left: 10px;
              text-align: left;
              // background: #000;
            }
          }
          .readonly {
            /deep/ [readonly="readonly"] {
              background: #eaeaea;
            }
            /deep/ .el-checkbox[readonly="readonly"] {
              background: none;
            }
          }
          .mustinput {
            /deep/ .el-form-item__label {
              color: red;
            }
          }
        }
      }
    }
  }
  .iptline {
    label {
      font-size: 5vw !important;
      line-height: 5vw;
      padding-top: 6vw;
      text-align: center;
      p {
        font-size: 3.45vw;
      }
      /deep/ .preview-cover {
        position: absolute;
        bottom: 0;
        box-sizing: border-box;
        width: 100%;
        padding: 4px;
        color: #fff;
        font-size: 12px;
        text-align: center;
        background: rgba(0, 0, 0, 0.3);
      }
    }
  }
  .empPic {
    padding: 10px 0 20px;
    .right_titlepar:before {
      content: "";
      position: absolute;
      width: 2.66667vw;
      height: 11.46667vw;
      left: -1.33333vw;
      top: 0;
      bottom: 0;
      background-color: #287eff;
      border-radius: 1.33333vw;
    }
    .right_titlepar {
      position: relative;
      // border-bottom: 1px solid #ccc;
      border-bottom: 1px solid #bababc;
      // #bababc
      padding: 0 4vw;
      .right_title {
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 5vw;
        min-height: 11.46667vw;
        // line-height: 11.46667vw;
        .msgTitle {
          width: 100%;
          text-align: center;
        }
        .lump {
          height: 3vw;
          width: 1vw;
          // background: $active-color;
          display: inline-block;
          margin-right: 1vw;
        }
        .titlebtn {
          background: none;
          border: none;
          font-size: 20px;
        }
        .titlebtn:hover {
          background: none;
          border: none;
          // color: $active-color;
        }
      }
    }
    .picbox {
      padding: 10px 0;
      display: flex;
      align-items: center;
      // justify-content: space-around;
      flex-wrap: wrap;
      .pp {
        width: 33%;
        font-size: 30px;
        text-align: center;
        position: relative;
        .van-uploader__preview-delete {
          position: absolute;
          right: 0;
          top: 0;
          z-index: 1;
          .van-icon {
            font-size: 14px;
            color: #fff;
            position: absolute;
            right: 5px;
            top: 7px;
            z-index: 1;
          }
        }
      }
    }
  }
  .tree_popup {
    z-index: 6666 !important;
    .tree_title {
      height: 90px;
      text-align: center;
      span {
        font-size: 36px;
        font-weight: bold;
      }
    }
    .tree_search {
      height: 100px;
    }
    .tree_head {
      height: 90px;
      white-space: nowrap;
      overflow-x: auto;
      display: flex;
      align-items: center;
      span {
        font-size: 32px;
      }
      .theLast {
        color: #969799;
        margin-right: 10px;
      }
      .noLast {
        color: #1491f7;
      }
      .head_start {
        color: #1491f7;
        padding: 0 10px 0 20px;
      }
      .division {
        color: #969799;
        padding: 0 16px;
      }
    }
    .van-divider::before {
      border-width: 20px 0 0;
    }

    .tree_body {
      height: calc(100% - 5.7rem);
      overflow: auto;
      .parents_cell {
        .van-checkbox {
          padding-right: 10px;
        }
        .van-cell__title {
          flex: 1 1 83%;
        }
        .van-cell__value {
          flex: 1 1 17%;
          div {
            display: flex;
            align-items: center;
            justify-content: end;
            border-left: 1px solid #969799;
          }
          .haveClo {
            color: #1491f7;
          }
          .noClo {
            color: #969799;
          }
          .van-icon {
            padding: 0 10px;
          }
        }
      }
      .childs_cell,
      .other_cell {
        .van-cell__title {
          display: flex;
          align-items: center;
          .van-button {
            border-radius: 12px;
            font-size: 28px;
          }
          .check_name {
            padding-left: 10px;
          }
        }
      }
      // .other_cell {
      //   .van-cell__title {
      //     display: flex;
      //     align-items: center;
      //     .van-button {
      //       border-radius: 12px;
      //       font-size: 28px;
      //     }
      //   }
      // }
    }
    .tree_foot {
      position: absolute;
      bottom: 0;
      width: 100%;
      background: #fff;
      display: flex;
      justify-content: space-evenly;
      .van-button {
        width: 30vw;
        margin-bottom: 10px;
      }
    }

    /deep/.van-popup__close-icon--top-left {
      top: 25px !important;
      left: 10px !important;
    }
  }
}
</style>
